<template>
  <v-card>
    <v-card-title :class="isMobile ? 'ma-0 pa-0' : ''">
      <v-container fluid>
        <v-row
          no-gutters
          align="center"
          justify="space-between"
          v-if="!isMobile"
        >
          <v-col cols="4" no-gutters>
            <v-row align="baseline">
              <span v-if="operatorsListFlag" class="my-0 mx-2 warning">
                {{ `&nbsp;  ${$t('modeShowOperatorsNotification')} &nbsp;` }}
              </span>
              <!-- Busqueda avanzada: muestra color de fondo igual al boton activado y tooltip multilinea igual al boton -->
              <v-tooltip v-else-if="currentAdvancedSearch" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span
                    v-bind="attrs"
                    v-on="on"
                    class="my-0 ml-0 mr-2 warningLow"
                  >
                    {{ `&nbsp;  ${$t('navigationPage.notifications')} &nbsp;` }}
                  </span>
                </template>
                <div v-html="tooltipAdvancedSearchButton()"></div>
              </v-tooltip>
              <!-- modo normal por defecto -->
              <span v-else class="my-0 mx-2">
                {{ $t('navigationPage.notifications') }}
              </span>
              <!-- periodo -->
              <span
                v-if="!loadAllNotifications"
                class="my-0 subtitle-2 pt-1 pb-0 px-2 rounded"
                :style="{
                  backgroundColor: $vuetify.theme.dark ? '#2e7d32' : '#e8f5e9', // verde
                  display: 'inline-block',
                }"
              >
                {{
                  $t('periods.lastConfiguredPeriod', {
                    amount: getLoadLastDays,
                    unit: $t('periods.days'),
                  })
                }}
              </span>
              <span v-else class="my-0 subtitle-2 text--secondary">
                {{ buildTextCurrentPeriod() }}
              </span>
              <v-spacer />
              <v-col cols="auto">
                <v-btn
                  data-v-step="103"
                  v-if="userCanChangePeriod"
                  rounded
                  small
                  :loading="loadingAll"
                  class="ml-0 mr-0 mb-2 mt-2 secondary--text"
                  color="primary"
                  :disabled="false"
                  @click="changePeriodDialog = true"
                >
                  {{ $t('periods.selectPeriod') }}
                </v-btn>
                <ChangePeriodDialog
                  v-if="changePeriodDialog && userCanChangePeriod && periods"
                  :periods="periods"
                  :currentPeriod="currentPeriod || undefined"
                  @setPeriod="(newPeriod) => setCurrentPeriod(newPeriod)"
                />
                <DialogButton
                  section="notifications"
                  subsection="notificationList"
                />
              </v-col>
            </v-row>

            <!-- Limite. Tener en cuenta si está visible el modo operadores-por-notificacion que ocupa espacio extra  -->
            <v-row :dense="!operatorsListFlag" v-if="limitReached">
              <!-- Tooltip para el icono -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    :class="!operatorsListFlag ? 'ml-1' : 'ml-3'"
                    color="warning"
                    small
                  >
                    mdi-alert
                  </v-icon>
                </template>
                <span>{{
                  $t('periods.limitReachedTooltip', {
                    limit: getLoadLastDaysLimit,
                  })
                }}</span>
              </v-tooltip>

              <!-- Tooltip para el texto -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span
                    v-bind="attrs"
                    v-on="on"
                    class="my-0 ml-1 subtitle-2 text--secondary"
                  >
                    {{
                      $t('periods.limitReached', {
                        limit: getLoadLastDaysLimit,
                      })
                    }}
                  </span>
                </template>
                <span>{{
                  $t('periods.limitReachedTooltip', {
                    limit: getLoadLastDaysLimit,
                  })
                }}</span>
              </v-tooltip>
            </v-row>

            <!-- eliminar mesaje y boton de Ultima actualizacion
            <v-row
              align="baseline"
              v-if="$store.state.user.lastRetrievedNotifications"
            >
              <span style="color: grey; font-size: 14px" class="pl-2 pr-1 mt-3">
                {{ $t('lastUpdated') }}:
                {{
                  $d(
                    $store.state.user.lastRetrievedNotifications.toDate(),
                    'i18nDateAndHour'
                  )
                }}
              </span>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    x-small
                    style="text-transform: none"
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="updateNotifications()"
                    :disabled="
                      $store.state.user.needsCertEmpresa ||
                      isUpdatingNotifications
                    "
                  >
                    <v-icon v-if="!isUpdatingNotifications">
                      mdi-reload
                    </v-icon>
                    <v-icon v-else> mdi-autorenew mdi-spin </v-icon>
                  </v-btn>
                </template>
                <div>
                  {{ $t('refreshNow') }}
                </div>
              </v-tooltip>
            </v-row-->
          </v-col>
          <v-col cols="4" no-gutters>
            <AppPlanProgress
              v-if="isAdminUser"
              icon="mdi-mailbox"
              :current="notificationsUsed"
              :max="notificationsMax"
            />
          </v-col>

          <!-- Boton de Busqueda avanzada -->
          <v-col cols="auto">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="userCanUseAdvancedSearch"
                  elevation="1"
                  fab
                  small
                  class="secondary--text ma-1"
                  v-bind="attrs"
                  v-on="on"
                  id="advanced-search-btn"
                  :disabled="loadingData"
                  :color="currentAdvancedSearch ? 'warningLow' : 'primary'"
                  @click.stop="advancedSearchDialog = true"
                >
                  <v-icon> mdi-magnify-plus </v-icon>
                </v-btn>
              </template>
              <div v-html="tooltipAdvancedSearchButton()"></div>
            </v-tooltip>
            <AdvancedSearchDialog
              v-if="advancedSearchDialog && userCanUseAdvancedSearch"
              :currentAdvancedSearch="currentAdvancedSearch || undefined"
              :cifs="loadedCifs.filter((c) => c.notificacionesActivas)"
              :status="getStatusList()"
              :users="uniqueManagers"
              :alertStatus="getAlertStatusList()"
              @setAdvancedSearch="
                (newAdvancedSearch) =>
                  setCurrentAdvancedSearch(newAdvancedSearch)
              "
            />
          </v-col>

          <v-col cols="2" no-gutters>
            <v-text-field
              data-v-step="104"
              class="my-0 py-0"
              v-model="search"
              @change="searchChange"
              @focus="isSearchFocused = true"
              @blur="isSearchFocused = false"
              clearable
              prepend-inner-icon="mdi-magnify"
              :label="searchLabel"
              hide-details
            >
            </v-text-field>
          </v-col>
          <v-col cols="auto">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="isAdminUser && !isColectivoUser"
                  elevation="1"
                  fab
                  small
                  class="secondary--text ma-1"
                  v-bind="attrs"
                  v-on="on"
                  id="list-operators"
                  :disabled="loadingData"
                  :color="operatorsListFlag ? 'warning' : 'primary'"
                  @click.stop="switchOperatorsListFlag()"
                >
                  <v-icon> mdi-account-group </v-icon>
                </v-btn>
              </template>
              <div>
                {{ $t('notificationActions.title.operatorsList') }}
              </div>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  elevation="1"
                  fab
                  small
                  class="primary secondary--text ma-1"
                  v-bind="attrs"
                  v-on="on"
                  id="export-data"
                  @click.stop="dialogmails = true"
                >
                  <v-icon>mdi-file-export</v-icon>
                </v-btn>
              </template>
              <div>
                {{ $t('notificationActions.title.export') }}
              </div>
            </v-tooltip>

            <!-- Cuadro de diálogo de confirmación de correos -->
            <v-dialog v-model="dialogmails" max-width="500">
              <v-card>
                <v-card-title class="headline">
                  {{ $t('notificationActions.export.confirmTitle') }}
                </v-card-title>
                <v-card-text>
                  <v-checkbox
                    v-model="includeMails"
                    :label="$t('notificationActions.export.confirmMessage')"
                  ></v-checkbox>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="confirmExport()">
                    {{ $t('notificationActions.export.withEmails') }}
                  </v-btn>
                  <v-btn color="error" text @click="dialogmails = false">
                    {{ $t('notificationActions.export.cancel') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <MassiveActionsButton
              objectType="notifications"
              v-if="
                !isColectivoUser &&
                (!this.$store.state.user.parentRef ||
                  this.$store.state.user.processNotification === true ||
                  this.$store.state.user.downloadNotification === true)
              "
              :actions="[
                {
                  title: 'changeStatus',
                  disabled: !(
                    this.$store.state.user.processNotification ?? true
                  ),
                  icon: 'mdi-swap-horizontal',
                },
                {
                  title: 'openNotification',
                  disabled: !(
                    this.$store.state.user.downloadNotification ?? true
                  ),
                  icon: 'mdi-email-open-outline',
                  maxMassiveActionItems: maxMassiveActionItems,
                },
                {
                  title: 'setResponsible',
                  disabled: !(
                    this.$store.state.user.processNotification ?? true
                  ),
                  icon: 'mdi-account-hard-hat-outline',
                },
                {
                  title: 'setAlert',
                  disabled: !(
                    this.$store.state.user.processNotification ?? true
                  ),
                  icon: 'mdi-bell',
                },
                {
                  title: 'setObservation',
                  disabled: !(
                    this.$store.state.user.processNotification ?? true
                  ),
                  icon: 'mdi-comment-processing-outline',
                },
                {
                  title: 'downloadFiles',
                  disabled: !(
                    this.$store.state.user.processNotification ?? true
                  ),
                  icon: 'mdi-folder-arrow-down-outline',
                },
              ]"
              :items="selectedRows"
              :contextOperators="operators"
              @actionSelected="(value) => (massiveActionSelected = value)"
              @setMassiveActionData="setMassiveActionData"
              @removeLastItem="selectedRows.pop()"
              @removeItems="(items) => removeItems(items)"
            />
            <NotificationDialog
              v-if="
                !$store.getters.isDemoEnv &&
                (!isOperatorUser || $store.state.user?.processNotification)
              "
              action="create"
              :notification="{}"
              :cifs="loadedCifs.filter((c) => c.notificacionesActivas)"
            />
          </v-col>
        </v-row>
        <v-col v-else>
          <!-- Mobile ------------------------------------------------------------------------- -->
          <v-row align="baseline">
            <span v-if="operatorsListFlag" class="my-0 mx-2 warning">
              {{ `&nbsp;  ${$t('modeShowOperatorsNotification')} &nbsp;` }}
            </span>
            <!-- Busqueda avanzada: muestra color de fondo igual al boton activado y tooltip multilinea igual al boton -->
            <v-tooltip v-else-if="currentAdvancedSearch" bottom>
              <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                  class="my-0 ml-0 mr-2 warningLow"
                >
                  {{ `&nbsp;  ${$t('navigationPage.notifications')} &nbsp;` }}
                </span>
              </template>
              <div v-html="tooltipAdvancedSearchButton()"></div>
            </v-tooltip>
            <!-- modo normal por defecto -->
            <span v-else class="my-0 mx-2">
              {{ $t('navigationPage.notifications') }}
            </span>
            <!-- periodo -->
            <span
              v-if="!loadAllNotifications"
              class="my-0 subtitle-2 pt-1 pb-0 px-2 rounded"
              :style="{
                backgroundColor: $vuetify.theme.dark ? '#2e7d32' : '#e8f5e9', // verde
                display: 'inline-block',
              }"
            >
              {{
                $t('periods.lastConfiguredPeriod', {
                  amount: getLoadLastDays,
                  unit: $t('periods.days'),
                })
              }}
            </span>
            <span v-else class="my-0 subtitle-2 text--secondary">
              {{ buildTextCurrentPeriod() }}
            </span>
            <v-spacer />
            <v-col cols="auto" class="mx-n3 mb-6">
              <v-btn
                v-if="userCanChangePeriod"
                rounded
                small
                :loading="loadingAll"
                class="mx-0 secondary--text"
                color="primary"
                :disabled="false"
                @click="changePeriodDialog = true"
              >
                {{ $t('periods.selectPeriod') }}
              </v-btn>
              <ChangePeriodDialog
                v-if="changePeriodDialog && userCanChangePeriod && periods"
                :periods="periods"
                :currentPeriod="currentPeriod || periods[0]"
                @setPeriod="(newPeriod) => setCurrentPeriod(newPeriod)"
              />
              <DialogButton
                section="notifications"
                subsection="notificationList"
              />
            </v-col>
          </v-row>

          <!-- Limite. En modo mobile no está activa la vista operadores-por-notificacion -->
          <v-row dense v-if="limitReached">
            <!-- Tooltip para el icono -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  :class="!operatorsListFlag ? 'ml-1' : 'ml-3'"
                  color="warning"
                  small
                >
                  mdi-alert
                </v-icon>
              </template>
              <span>{{
                $t('periods.limitReachedTooltip', {
                  limit: getLoadLastDaysLimit,
                })
              }}</span>
            </v-tooltip>

            <!-- Tooltip para el texto -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                  class="my-0 ml-1 subtitle-2 text--secondary"
                >
                  {{
                    $t('periods.limitReached', {
                      limit: getLoadLastDaysLimit,
                    })
                  }}
                </span>
              </template>
              <span>{{
                $t('periods.limitReachedTooltip', {
                  limit: getLoadLastDaysLimit,
                })
              }}</span>
            </v-tooltip>
          </v-row>

          <v-row>
            <!-- Boton de Busqueda avanzada -->
            <!--v-col cols="auto"-->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="userCanUseAdvancedSearch"
                  elevation="1"
                  fab
                  small
                  class="secondary--text my-0 mx-0 mt-n2 mr-2"
                  v-bind="attrs"
                  v-on="on"
                  id="advanced-search-btn"
                  :disabled="loadingData"
                  :color="currentAdvancedSearch ? 'warningLow' : 'primary'"
                  @click.stop="advancedSearchDialog = true"
                >
                  <v-icon> mdi-magnify-plus </v-icon>
                </v-btn>
              </template>
              <div v-html="tooltipAdvancedSearchButton()"></div>
            </v-tooltip>
            <AdvancedSearchDialog
              v-if="advancedSearchDialog && userCanUseAdvancedSearch"
              :currentAdvancedSearch="currentAdvancedSearch || undefined"
              :cifs="loadedCifs.filter((c) => c.notificacionesActivas)"
              :status="getStatusList()"
              :users="uniqueManagers"
              :alertStatus="getAlertStatusList()"
              @setAdvancedSearch="
                (newAdvancedSearch) =>
                  setCurrentAdvancedSearch(newAdvancedSearch)
              "
            />
            <!--/v-col-->
            <v-text-field
              class="my-0 py-0"
              v-model="search"
              @change="searchChange"
              @focus="isSearchFocused = true"
              @blur="isSearchFocused = false"
              clearable
              prepend-icon="mdi-magnify"
              :label="searchLabel"
              hide-details
            >
            </v-text-field>
          </v-row>
          <v-row class="mt-3 d-flex justify-center">
            <v-col>
              <AppPlanProgress
                class="ml-4 mr-4"
                icon="mdi-mailbox"
                textSize="h5"
                :current="notificationsUsed"
                :max="notificationsMax"
              />
            </v-col>
          </v-row>
          <v-row class="mt-3 d-flex justify-center">
            <v-col align="center">
              <v-btn
                elevation="1"
                fab
                small
                class="primary secondary--text ma-1"
                id="export-data"
                @click.stop="dialogmails = true"
              >
                <v-icon> mdi-file-export </v-icon>
              </v-btn>
              <!-- Cuadro de diálogo de confirmación de correos -->
              <v-dialog v-model="dialogmails" max-width="500">
                <v-card>
                  <v-card-title class="headline">
                    {{ $t('notificationActions.export.confirmTitle') }}
                  </v-card-title>
                  <v-card-text>
                    <v-checkbox
                      v-model="includeMails"
                      :label="$t('notificationActions.export.confirmMessage')"
                    ></v-checkbox>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="confirmExport()">
                      {{ $t('notificationActions.export.withEmails') }}
                    </v-btn>
                    <v-btn color="error" text @click="dialogmails = false">
                      {{ $t('notificationActions.export.cancel') }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <MassiveActionsButton
                objectType="notifications"
                v-if="
                  !isColectivoUser &&
                  (!this.$store.state.user.parentRef ||
                    this.$store.state.user.processNotification === true ||
                    this.$store.state.user.downloadNotification === true)
                "
                :actions="[
                  {
                    title: 'changeStatus',
                    disabled: !(
                      this.$store.state.user.processNotification ?? true
                    ),
                    icon: '',
                  },
                  {
                    title: 'openNotification',
                    disabled: !(
                      this.$store.state.user.downloadNotification ?? true
                    ),
                    icon: '',
                    maxMassiveActionItems: maxMassiveActionItems,
                  },
                  {
                    title: 'setResponsible',
                    disabled: !(
                      this.$store.state.user.processNotification ?? true
                    ),
                    icon: '',
                  },
                  {
                    title: 'setAlert',
                    disabled: !(
                      this.$store.state.user.processNotification ?? true
                    ),
                    icon: '',
                  },
                  {
                    title: 'setObservation',
                    disabled: !(
                      this.$store.state.user.processNotification ?? true
                    ),
                    icon: '',
                  },
                  {
                    title: 'downloadFiles',
                    disabled: !(
                      this.$store.state.user.processNotification ?? true
                    ),
                    icon: '',
                  },
                ]"
                :items="selectedRows"
                :contextOperators="operators"
                @actionSelected="(value) => (massiveActionSelected = value)"
                @setMassiveActionData="setMassiveActionData"
                @removeLastItem="selectedRows.pop()"
                @removeItems="(items) => removeItems(items)"
              />
              <NotificationDialog
                v-if="
                  !$store.getters.isDemoEnv &&
                  (!isOperatorUser || $store.state.user?.processNotification)
                "
                action="create"
                :notification="{}"
                :cifs="loadedCifs.filter((c) => c.notificacionesActivas)"
              />
            </v-col>
          </v-row>

          <!-- eliminar mesaje y boton de Ultima actualizacion          
          <v-row
            class="mt-3 d-flex justify-center"
            v-if="$store.state.user.lastRetrievedNotifications"
          >
            <span style="color: grey; font-size: 14px" class="pl-2 pr-1">
              <b>{{ $t('lastUpdated') }} </b>:
              {{
                $d(
                  $store.state.user.lastRetrievedNotifications.toDate(),
                  'i18nDateAndHour'
                )
              }}
            </span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  x-small
                  class="mt-2"
                  style="text-transform: none"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="updateNotifications()"
                  :disabled="
                    $store.state.user.needsCertEmpresa ||
                    isUpdatingNotifications
                  "
                >
                  <v-icon v-if="!isUpdatingNotifications"> mdi-reload </v-icon>
                  <v-icon v-else> mdi-autorenew mdi-spin </v-icon>
                </v-btn>
              </template>
              <div>
                {{ $t('refreshNow') }}
              </div>
            </v-tooltip>
          </v-row-->
        </v-col>
      </v-container>
      <v-spacer></v-spacer>
    </v-card-title>

    <AppSkeleton data-v-step="102" :condition="loading" type="notificationList">
      <template v-slot:skeleton-content>
        <v-data-table
          ref="dataTable"
          v-model="selectedRows"
          :loading="loadingData"
          :headers="headers"
          :items="filteredNotifications"
          :items-per-page="25"
          @click:row="openNotificationDetail"
          :footer-props="{ 'items-per-page-options': [10, 25, 50, 100 /*-1*/] }"
          :options="options"
          @update:options="optionsChange"
          @item-selected="checkSelectedItem"
          @toggle-select-all="checkSelectedItems"
          class="elevation-1"
          :show-select="!!massiveActionSelected"
          fixed-header
          :height="tableHeight"
          :item-class="rowClass"
        >
          <!-- ---------------------------------------------------------
            Footer personalizado.
            Añade información de paginación y permite navegar
            directamente a una página introduciendo su número.
          ---------------------------------------------------------- -->
          <template
            v-slot:[`footer.page-text`]="{ pageStart, pageStop, itemsLength }"
          >
            {{ pageStart }}–{{ pageStop }} {{ $t('of') }} {{ itemsLength }}

            &nbsp; | &nbsp;

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span class="page-selector" v-on="on">
                  {{ $t('page') }}
                  <input
                    v-model.number="pageInput"
                    type="number"
                    class="page-input"
                    min="1"
                    :max="totalPages"
                    @focus="$event.target.select()"
                    @keyup.enter="goToPage"
                    @blur="goToPage"
                    v-on="on"
                  />
                  / {{ totalPages }}
                </span>
              </template>
              <span v-html="goToPageTooltip"></span>
            </v-tooltip>
          </template>

          <!-- header Notificaciones sin NIF_Titular -->
          <template
            v-if="notificationsWithoutNifTitularCount"
            v-slot:[`header.nif_titular`]="{ header }"
          >
            <i class="no-italics">
              <span>{{ header.text }}</span>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }"
                  >({{ notificationsWithoutNifTitularCount }})
                  <v-icon v-bind="attrs" v-on="on" class="ml-1" color="warning">
                    mdi-alert
                  </v-icon>
                </template>
                <span>
                  {{ $t('notificationsWithoutNifTitular') }}:
                  {{ notificationsWithoutNifTitularCount }}
                </span>
              </v-tooltip>
            </i>
          </template>

          <!-- item NIF_Titular -->
          <template v-slot:[`item.nif_titular`]="{ item }">
            <span v-if="!isEmptyNifTitular(item)" class="nif-wrapper">
              {{ item.nif_titular }}

              <!-- Si el titular original esta modificado, añadimos icono + tooltip -->
              <v-tooltip top v-if="isTitularOriginalModificado(item)">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="warning"
                    size="20"
                    class="ml-1"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-information
                  </v-icon>
                </template>
                <span v-html="getTitularOriginalTooltip(item)"></span>
              </v-tooltip>
            </span>
            <span v-else class="without-nif-alarm">
              {{ $t('notificationWithoutNifTitular') }}
            </span>
          </template>

          <template v-slot:[`item.operators`]="{ item }">
            <span v-if="item.operators">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    <v-chip
                      class="ma-2 white--text"
                      :color="
                        item.operators.length == 0
                          ? 'error'
                          : item.operators.length == 1
                          ? 'warning'
                          : 'primary'
                      "
                    >
                      {{ item.operators.length }}
                    </v-chip>
                  </span>
                </template>
                <div width="300">
                  <!-- mostrar avatar y nombre operador -->
                  <ul v-if="item.operators.length">
                    <li
                      v-for="(operator, index) in item.operators"
                      :key="index"
                    >
                      <v-row align="center">
                        <AppAvatar
                          class="mr-2 mt-3 mb-3"
                          :userName="operator.fullName"
                          :userAvatar="operator.avatar"
                          avatarSize="30"
                          iconSize="24"
                          avatarColor="primary"
                          initialsColor="secondary"
                        />
                        <span class="mr-2 mt-3 mb-3">
                          {{ operator.fullName }}
                        </span>
                      </v-row>
                    </li>
                  </ul>
                  <ul v-else>
                    <li>
                      {{ $t('withoutOperators') }}
                    </li>
                  </ul>
                </div>
              </v-tooltip>
            </span>
          </template>

          <template v-slot:[`item.alert`]="{ item }">
            <v-container>
              <v-row align="center">
                <AlertIcon :large="true" v-if="item.alert" :alert="item.alert">
                </AlertIcon>
                <AlertDialog
                  v-else-if="
                    !isOperatorUser || $store.state.user?.processNotification
                  "
                  :asset="item"
                  :isDisabled="
                    isOperatorUser && !$store.state.user?.processNotification
                  "
                  objectType="notifications"
                />
              </v-row>
            </v-container>
          </template>

          <template v-slot:[`item.id`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">{{
                  item.id.substring(0, 3) +
                  '...' +
                  item.id.substring(item.id.length - 3)
                }}</span>
              </template>
              <div width="300">
                {{ item.id }}
              </div>
            </v-tooltip>
          </template>
          <!-- muestra el concepto de la notificacion + conceptoXML si existe en los metadatas -->
          <template v-slot:[`item.concepto`]="{ item }">
            <span v-html="joinConceptsToPrettyPrint(item)"></span>
          </template>

          <template v-if="!isMobile" v-slot:[`item.estado`]="{ item }">
            <v-container>
              <v-row>
                <v-chip
                  class="ma-2 white--text"
                  :color="getNotificationStatus(item).color"
                  id="enter-notif-detail"
                >
                  {{ $t(getNotificationStatus(item).status) }}

                  <v-tooltip
                    max-width="400"
                    bottom
                    v-if="item.aproximateOpenningTime"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-progress-circular
                        v-bind="attrs"
                        v-on="on"
                        class="ml-1"
                        indeterminate
                        :size="12"
                        :width="1"
                        color="white"
                      />
                    </template>
                    <div width="300">
                      {{ $t('notificationOpensIn') }}:
                      <TimerCountdown
                        :starttime="new Date()"
                        :endtime="item.aproximateOpenningTime.toDate()"
                        :hideMessage="true"
                        from="NotificationsList"
                      />
                    </div>
                  </v-tooltip>
                </v-chip>
              </v-row>
            </v-container>
          </template>
          <!-- modo movil -------------------------------- -->
          <template v-else v-slot:[`item.estado`]="{ item }">
            <v-container>
              <v-row align="center">
                <AlertIcon v-if="item.alert" :alert="item.alert"></AlertIcon>

                <v-chip
                  class="ma-2 white--text"
                  :color="getNotificationStatus(item).color"
                >
                  {{ $t(getNotificationStatus(item).status) }}
                </v-chip>
                <AppAvatar
                  v-if="item.manager"
                  :userName="fullName(item.manager)"
                  :userAvatar="item.manager?.avatarURL"
                  :isGroup="isGroup(item.managerRef)"
                  :avatarSize="isGroup(item.managerRef) ? '34' : '30'"
                  :isDisabledOrDeleted="
                    isGroup(item.managerRef)
                      ? item.manager.disabled || item.manager.deleted
                      : false
                  "
                  :initialsSize="isGroup(item.managerRef) ? 11 : 14"
                  iconSize="24"
                  avatarColor="primary"
                  initialsColor="secondary"
                  :showWarn="
                    item.manager.disabled ||
                    !item.managerAccepted ||
                    item.manager.deleted ||
                    item.overlapIconColor === 'warning' ||
                    item.overlapIconColor === 'error'
                  "
                  :overlapIconColor="item.overlapIconColor"
                />
              </v-row>
            </v-container>
          </template>

          <template v-slot:[`item.tipo_envio`]="{ item }">
            <span>
              {{ $t(getNotificationType(item).name) }}
            </span>
          </template>

          <!-- Responsable -->
          <template v-slot:[`item.manager`]="{ item }">
            <span v-if="item.manager">
              <v-tooltip
                top
                :content-class="
                  isGroup(item.managerRef) ? 'tooltip-no-transparency' : ''
                "
              >
                <template v-slot:activator="{ on, attrs }">
                  <span
                    v-bind="attrs"
                    v-on="{
                      ...on,
                      mouseenter: (e) => onActivatorMouseEnter(e, item, on),
                    }"
                  >
                    <AppAvatar
                      v-if="item.manager"
                      :userName="fullName(item.manager)"
                      :userAvatar="item.manager?.avatarURL"
                      :isGroup="isGroup(item.managerRef)"
                      :isDisabledOrDeleted="
                        isGroup(item.managerRef)
                          ? item.manager.disabled || item.manager.deleted
                          : false
                      "
                      :avatarSize="isGroup(item.managerRef) ? '34' : '30'"
                      :initialsSize="isGroup(item.managerRef) ? 11 : 14"
                      fab
                      small
                      iconSize="24"
                      avatarColor="primary"
                      initialsColor="secondary"
                      :showWarn="
                        item.manager.disabled ||
                        !item.managerAccepted ||
                        item.manager.deleted ||
                        item.overlapIconColor === 'warning' ||
                        item.overlapIconColor === 'error'
                      "
                      :overlapIconColor="item.overlapIconColor"
                    />
                  </span>
                </template>
                <!-- Contenido del tooltip -->
                <div v-if="isGroup(item.managerRef)">
                  <div>
                    <span
                      >{{ $t('group') }}: {{ fullName(item.manager) }}
                      <b v-show="item.manager.deleted" class="group-deleted">
                        {{ $t('groupDeleted') }}
                      </b>
                    </span>
                  </div>
                </div>
                <div v-else>
                  {{ fullName(item.manager) }}
                </div>

                <div v-if="!item.managerAccepted">
                  <div v-if="isGroup(item.managerRef)">
                    {{ $t('waitGroupManager') }}
                  </div>
                  <div v-else>
                    {{ $t('waitManager') }}
                  </div>
                </div>

                <div v-if="item.manager.disabled">
                  {{ $t('userDisabled') }}
                </div>
                <div v-if="item.canBeManager === false">
                  {{ $t('operatorWithoutAccess') }}
                </div>

                <div
                  v-if="
                    item.groupAccess?.summary?.acceptedOperatorDeletedFromGroup
                  "
                  class="d-flex align-start"
                >
                  <v-icon color="error" class="mr-2 m">mdi-alert </v-icon>
                  <div>
                    <div>{{ $t('acceptedOperatorDeletedFromGroup') }}:</div>
                    <div>
                      {{
                        item.groupAccess?.summary
                          ?.acceptedOperatorDeletedFromGroupFullname
                      }}
                    </div>
                  </div>
                </div>

                <!--Mostrar lista de operadores del grupo responsable -->
                <div v-if="isGroup(item.managerRef)">
                  <div
                    style="display: block; margin-top: 8px; margin-bottom: 10px"
                  >
                    {{ $t('groupOperators') }}:
                  </div>

                  <!-- estado: cargando -->
                  <div
                    v-if="item.groupAccess?.status !== 'ready'"
                    class="tooltip-loading"
                  >
                    <v-progress-circular indeterminate size="20" width="2" />
                  </div>

                  <!-- estado: cargado -->
                  <template v-else>
                    <!-- si hay operadores -->
                    <!-- mostrar avatar y nombre de los primeros N operadores del grupo -->
                    <ul v-if="getGroupOperators(item).length">
                      <li
                        v-for="(operator, index) in getGroupOperatorsPreview(
                          item
                        )"
                        :key="index"
                      >
                        <v-row align="center">
                          <AppAvatar
                            class="mr-2 mt-3 mb-3"
                            :userName="operator.fullName"
                            :userAvatar="operator.avatarURL"
                            :avatarSize="isGroup(item.managerRef) ? '34' : '30'"
                            :initialsSize="isGroup(item.managerRef) ? 11 : 14"
                            iconSize="24"
                            avatarColor="primary"
                            initialsColor="secondary"
                            :showWarn="
                              item.groupAccess.map[operator.id]?.hasError
                            "
                            :overlapIconColor="
                              item.groupAccess.map[operator.id]?.hasError
                                ? 'error'
                                : undefined
                            "
                          />

                          <span class="mr-2 mt-3 mb-3">
                            {{ operator.fullName }} :
                            {{ operatorAccessText(operator, item) }}
                            <template
                              v-if="
                                item.groupAccess?.map[operator.id]?.response
                                  .responded
                              "
                            >
                              <v-icon
                                :color="
                                  item.groupAccess.map[operator.id].response
                                    .color
                                "
                                size="15"
                                class="ml-1 mb-1"
                              >
                                mdi-circle
                              </v-icon>
                              {{
                                item.groupAccess.map[operator.id].response.text
                              }}
                            </template>
                          </span>
                        </v-row>
                      </li>
                      <br />
                    </ul>
                    <!-- Texto informativo, dentro del tooltip, cuando hay mas operadores de los mostrados -->
                    <div
                      v-if="
                        getGroupOperators(item).length > maxOperatorsPreview
                      "
                      class="group-operators-info"
                    >
                      <v-chip
                        small
                        _color="grey lighten-4"
                        _text-color="grey darken-3"
                        color="primary"
                        text-color="seconday"
                        class="operator-count-chip"
                      >
                        +{{
                          getGroupOperators(item).length - maxOperatorsPreview
                        }}
                      </v-chip>
                      <span class="operator-count-text">{{
                        $t('groupOperators')
                      }}</span>
                    </div>

                    <!-- estado: cargado pero grupo vacio -->
                    <div v-if="!getGroupOperators(item).length">
                      <ul>
                        <li>{{ $t('withoutOperators') }}</li>
                      </ul>
                    </div>
                  </template>
                </div>
              </v-tooltip>
            </span>
          </template>

          <template v-slot:[`item.fecha_puesta_disposicion`]="{ item }">
            {{ $d(item.fecha_puesta_disposicion, 'i18nDate') }}
          </template>
          <template v-slot:[`item.fecha_aceptacion`]="{ item }">
            <span v-if="item.fecha_aceptacion">
              {{ $d(item.fecha_aceptacion, 'i18nDate') }}
            </span>
            <span v-else-if="item.fecha_expiracion">
              <TimerCountdown
                :starttime="item.fecha_puesta_disposicion"
                :endtime="item.fecha_expiracion"
                from="NotificationsList"
              >
              </TimerCountdown>
            </span>
          </template>
          <template v-slot:[`item.contenido`]="{ item }">
            <v-container>
              <v-row class="mr-1">
                <v-col cols="4">
                  <!--         CONTENIDO            -->
                  <v-btn
                    v-if="
                      item.document &&
                      (!isOperatorUser || $store.state.user.processNotification)
                    "
                    icon
                    color="red lighten-2"
                    dark
                  >
                    <v-icon @click.stop="getNotification(item)">
                      mdi-file-document
                    </v-icon>
                  </v-btn>
                  <v-tooltip
                    v-else-if="
                      item.document &&
                      (!isOperatorUser ||
                        !$store.state.user.processNotification)
                    "
                    top
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        class="ma-1"
                        v-bind="attrs"
                        v-on="on"
                        color="grey lighten-1"
                      >
                        mdi-file-document
                      </v-icon>
                    </template>
                    <span>
                      {{
                        $t('contentNoProcessPermissionText', [
                          $t(getNotificationType(item).name),
                        ])
                      }}
                    </span>
                  </v-tooltip>
                  <v-tooltip v-else top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        class="ma-1"
                        v-bind="attrs"
                        v-on="on"
                        color="grey lighten-1"
                      >
                        mdi-file-document
                      </v-icon>
                    </template>
                    <span>
                      {{
                        $t('acceptToDocumentRequired', [
                          $t(getNotificationType(item).name),
                        ])
                      }}
                    </span>
                  </v-tooltip>
                </v-col>
                <v-col cols="4">
                  <!--           ANEXOS             -->
                  <v-dialog
                    v-if="
                      item.document &&
                      item.document.referenciaAnexos &&
                      (!isOperatorUser || $store.state.user.processNotification)
                    "
                    v-model="dialog"
                    width="800"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        color="blue lighten-2"
                        dark
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon> mdi-file-document-multiple </v-icon>
                      </v-btn>
                    </template>

                    <v-card
                      v-if="
                        !isMobile &&
                        (!isOperatorUser ||
                          $store.state.user.processNotification)
                      "
                    >
                      <v-card-title class="text-h5 grey lighten-2">
                        {{ $t('annexes') }}
                      </v-card-title>
                      <v-container fill-height fluid>
                        <v-row align="center" justify="center">
                          <v-col
                            v-for="anexe in item.document.referenciaAnexos"
                            v-bind:key="anexe.Id"
                            cols="4"
                          >
                            <v-card class="mx-auto pa-1">
                              <v-container fill-height fluid>
                                <v-row
                                  class="grey lighten-2"
                                  align="center"
                                  justify="center"
                                >
                                  <v-card-title>
                                    {{ anexe.nombre }}
                                  </v-card-title>
                                </v-row>
                                <v-row align="center" justify="center">
                                  <v-icon
                                    x-large
                                    class="ma-3"
                                    color="blue lighten-2"
                                  >
                                    mdi-file-document
                                  </v-icon>
                                </v-row>
                                <v-row align="center" justify="center">
                                  <v-btn
                                    @click.stop="getAnnexe(item, anexe)"
                                    class="ma-3"
                                    text
                                  >
                                    {{ $t('download') }}
                                    <v-icon x-large color="blue lighten-2">
                                      mdi-download
                                    </v-icon>
                                  </v-btn>
                                </v-row>
                              </v-container>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-container>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <!--@click="getAnnexe(item)"-->
                        <v-btn color="primary" text @click="dialog = false">
                          {{ $t('close') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-tooltip
                    v-else-if="
                      item.document &&
                      item.document.referenciaAnexos &&
                      (!isOperatorUser ||
                        !$store.state.user.processNotification)
                    "
                    top
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        class="ma-1"
                        v-bind="attrs"
                        v-on="on"
                        color="grey lighten-1"
                      >
                        mdi-file-document-multiple
                      </v-icon>
                    </template>
                    <span>
                      {{
                        $t('contentNoProcessPermissionText', [
                          $t(getNotificationType(item).name),
                        ])
                      }}
                    </span>
                  </v-tooltip>
                  <v-tooltip
                    v-else-if="item.document && !item.document.referenciaAnexos"
                    top
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        class="ma-1"
                        v-bind="attrs"
                        v-on="on"
                        color="grey lighten-1"
                      >
                        mdi-file-document-multiple
                      </v-icon>
                    </template>
                    <span>
                      {{
                        $t('noAnnexesAvailable', [
                          $t(getNotificationType(item).name),
                        ])
                      }}
                    </span>
                  </v-tooltip>
                  <v-tooltip v-else top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        class="ma-1"
                        v-bind="attrs"
                        v-on="on"
                        color="grey lighten-1"
                      >
                        mdi-file-document-multiple
                      </v-icon>
                    </template>
                    <span>
                      {{
                        $t('acceptToAnnexesRequired', [
                          $t(getNotificationType(item).name),
                        ])
                      }}
                    </span>
                  </v-tooltip>
                </v-col>
                <v-col cols="4">
                  <!--           ACUSE              -->
                  <v-btn
                    v-if="
                      getNotificationType(item).name == 'notification' &&
                      item.document &&
                      (!isOperatorUser || $store.state.user.processNotification)
                    "
                    icon
                    color="green lighten-2"
                    dark
                  >
                    <v-icon @click.stop="getAck(item)"> mdi-file-sign </v-icon>
                  </v-btn>
                  <v-tooltip
                    v-else-if="
                      getNotificationType(item).name == 'notification' &&
                      item.document &&
                      (!isOperatorUser ||
                        !$store.state.user.processNotification)
                    "
                    top
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        class="ma-1"
                        v-bind="attrs"
                        v-on="on"
                        color="grey lighten-1"
                      >
                        mdi-file-sign
                      </v-icon>
                    </template>
                    <span>
                      {{
                        $t('contentNoProcessPermissionText', [
                          $t(getNotificationType(item).name),
                        ])
                      }}
                    </span>
                  </v-tooltip>
                  <v-tooltip
                    v-else-if="
                      getNotificationType(item).name == 'notification' &&
                      !item.document
                    "
                    top
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        class="ma-1"
                        v-bind="attrs"
                        v-on="on"
                        color="grey lighten-1"
                      >
                        mdi-file-sign
                      </v-icon>
                    </template>
                    <span> {{ $t('acceptToAckRequired') }} </span>
                  </v-tooltip>
                  <v-tooltip v-else top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        class="ma-1"
                        v-bind="attrs"
                        v-on="on"
                        color="grey lighten-1"
                      >
                        mdi-file-sign
                      </v-icon>
                    </template>
                    <span> {{ $t('ackOnlyNotifications') }} </span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-container>
          </template>
        </v-data-table>
      </template>
    </AppSkeleton>
    <!--  <v-row align="center" justify="center">
      <v-col cols="12">
        <v-btn @click="createTestNotification">Crear Notification</v-btn>
      </v-col>
    </v-row>-->

    <TermsToAcceptDialog v-if="!isTermsAccepted" />

    <!-- Reutilizo el componente de Analytics para cargar las Notificaciones sin NIF titular -->
    <!-- y añado 2 nuevas propiedades al componente, manteniendo la compatibilidad hacia atras -->
    <!-- NO mostrar el dialogo modal de notificaciones sin nif titular en los siguientes casos: -->
    <!--   * si ya esta visible el dialogo modal de Cambiar Periodo de carga o -->
    <!--   * si ya esta visible el dialogo modal de Busqueda avanzada -->
    <NotificationsGridModal
      v-if="isSuperAdminUser || isSuperOperatorUser"
      :notifications="notificationsWithoutNifTitular"
      :showDialog="openGridNotifications && !changePeriodDialog"
      :title="$t('notificationsWithoutNifTitularDialog.title')"
      :icon="$t('notificationsWithoutNifTitularDialog.icon')"
      :iconColor="$t('notificationsWithoutNifTitularDialog.iconColor')"
      @dialog-closed="closeGrid"
    >
    </NotificationsGridModal>

    <!-- Modal cuando la carga de las notificaciones supera cierto tiempo, inicialmente establecido a 5 segundos -->
    <v-dialog v-model="showLongLoadingModal" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline">
          {{ $t('loadingDataTitle') }}
        </v-card-title>
        <v-card-text>
          <v-container class="text-center">
            <v-progress-circular
              indeterminate
              color="primary"
              size="40"
            ></v-progress-circular>
            <p>
              {{ $t('loadingDataMessage') }}
            </p>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="onCancel">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal de aviso de limite de filas seleccionadas en acciones masivas -->
    <v-dialog v-model="dialogLimitReached" max-width="350">
      <v-card>
        <v-card-title class="headline error white--text">
          {{ $t('massiveActions.limitReachedDialog.title') }}
        </v-card-title>
        <v-card-text class="pt-4">
          {{
            $t('massiveActions.limitReachedDialog.message', {
              maxMassiveActionItems: maxMassiveActionItems,
            })
          }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogLimitReached = false">
            {{ $t('massiveActions.limitReachedDialog.accept') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import {
  updateNotifications,
  listAllNotifications,
  getNotificationStatus,
  getNotificationType,
  openNotification,
  openAck,
  openAnnexe,
  operatorsCanViewNotification,
  buildStatusList,
  canOperatorBeManagerWithFilters,
  canOperatorBeManager,
  buildCifOperatorsIndex,
} from '@/services/notification-service'
import { buildAlertStatusList, getAlertStatus } from '@/services/alert-service'
import { Auth, NotificationsExportCSV } from '@/firebase-exports'

import AlertDialog from '@/components/alert/AlertDialog'
import AlertIcon from '@/components/alert/AlertIcon'
import getErrorText from '@/utils/get-error-text'
import { mapMutations } from 'vuex'
import TimerCountdown from '@/components/commons/TimerCountdown'
import { saveAs } from 'file-saver'
import { mapGetters } from 'vuex'
import DialogButton from '@/components/documentation/buttons/DialogButton'
import {
  demoDocumentBase64,
  demoAckBase64,
  demoAnnexeBase64,
} from '@/services/notification-demo-service'
import AppPlanProgress from '@/components/commons/AppPlanProgress'
import NotificationDialog from '@/components/notifications/dialog/NotificationDialog'
import ChangePeriodDialog from '@/components/notifications/dialog/ChangePeriodDialog'
import AdvancedSearchDialog from '@/components/notifications/dialog/AdvancedSearchDialog'
import { normalizeSearch } from '@/utils/string-utils'
import MassiveActionsButton from '@/components/massive-actions/MassiveActionsButton'
import { checkItem } from '@/utils/massive-actions'
import {
  getOperatorsSubscriptionReduced,
  withHeavyCache,
  clearOperatorsHeavyCache,
  GetDocumentFromReference,
} from '@/services/operator-service'
import { getGroupsSubscription } from '@/services/groups-service'
import { isGroupRef } from '@/services/user-service'
import TermsToAcceptDialog from '@/components/commons/TermsToAcceptDialog'
import NotificationsGridModal from '@/components/analytics/graphs/NotificationsGridModal'

const mime = require('mime-types')
const lodash = require('lodash')

export default {
  props: {
    loading: Boolean,
    cifs: Array,
    cifsList: Array,
    notificationsMax: Number,
    notificationsUsed: Number,
  },
  components: {
    TimerCountdown,
    AlertDialog,
    DialogButton,
    AlertIcon,
    AppPlanProgress,
    NotificationDialog,
    ChangePeriodDialog,
    AdvancedSearchDialog,
    MassiveActionsButton,
    TermsToAcceptDialog,
    NotificationsGridModal,
  },
  data() {
    return {
      loadAllNotifications: false,
      loadingAll: false,
      loadingData: false,
      dialog: false,
      search: '',
      debouncedSearch: '',
      handleDebouncedSearch: null,
      isSearchFocused: false,
      loadedCifs: [],
      loadedCifsList: [],
      options: {
        page: 1,
        itemsPerPage: 25,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: false,
      },
      massiveActionSelected: false,
      selectedRows: [],
      selectedRowsCopy: [],
      maxMassiveActionItems: 10,
      dialogLimitReached: false,
      massiveActionData: {},
      showWarn: true,
      operatorsListFlag: false,
      usersOperators: [],
      notificationsWithOperators: [],
      openGridNotifications: false,
      dialogmails: false,
      includeMails: false,
      showLongLoadingModal: false,
      loadingTimeout: null,
      changePeriodDialog: false,
      currentPeriod: '',
      allNotifications: [],
      advancedSearchDialog: false,
      currentAdvancedSearch: '',
      operatorsUnsubscribe: () => {},
      groupsUnsubscribe: () => {},
      operators: [],
      groups: null,
      pageInput: 1, // selector de pagina del listado
      hasScrolledToLastVisited: false,
    }
  },
  methods: {
    ...mapMutations([
      'setSnackbar',
      'setNotificationsListOptions',
      'setNotificationsSearch',
      'setNotificationsAdvancedSearch',
      'setNotificationsCurrentPeriod',
      'setNotificationsReloaded',
      'setNotificationNavigationContext',
    ]),
    /**
     * Checks that the selected notification fulfills the conditions to
     * be selected. This function is called only when 1 row is selected.
     * @param {Object} param0 Object containing the following values:
     * - item: The selected notification.
     * - value: If the selected notification is going to be checked or not.
     */
    async checkSelectedItem({ item, value }) {
      // We only check when the row is going to be checked
      if (value) {
        const result = await checkItem(
          this.massiveActionSelected,
          this.massiveActionData,
          item
        )

        // Removing the item from the list
        if (!result) {
          const index = this.selectedRows.findIndex((row) => row.id === item.id)
          if (index > -1) this.selectedRows.splice(index, 1)
        }

        this.selectedRowsCopy = [...this.selectedRows]
      }
    },
    /**
     * Checks that the selected notifications fulfills the conditions to
     * be selected. This function is called only when the "check all" button
     * is pressed.
     * @param {Object} param0 Object containing the following attributes:
     * - items: Selected notifications.
     * - value: If the notifications are going to be checked or not.
     */
    async checkSelectedItems({ items, value }) {
      for (const item of items) this.checkSelectedItem({ item, value })

      // If after checking we have the same number of elements
      // we must remove the items of that "page"
      if (this.selectedRows.length === this.selectedRowsCopy.length) {
        // Removing the page items
        for (const item of items) {
          const index = this.selectedRows.findIndex((row) => row.id === item.id)
          if (index > -1) this.selectedRows.splice(index, 1)
        }

        // Storing the copy of the items
        this.selectedRowsCopy = [...this.selectedRows]
      }
    },
    /**
     * Sets the massive action data.
     * @param {string} action Action selected
     */
    setMassiveActionData(data) {
      this.massiveActionData = data
    },
    /**
     * Given some indexes, remove them from a list.
     * @param {Array} indexes Array of indexes to remove.
     */
    removeItems(indexes = []) {
      const newList = []
      for (let i = 0; i < this.selectedRows.length; i++)
        if (!indexes.includes(i)) newList.push(this.selectedRows[i])

      this.selectedRows = newList
    },
    getNotificationStatus(notification) {
      return getNotificationStatus(notification)
    },
    getNotificationType(notification) {
      return getNotificationType(notification)
    },
    joinConceptsToPrettyPrint(notification) {
      return [
        notification.concepto,
        notification.metadatas?.find((m) => m.conceptoXML)?.conceptoXML,
      ]
        .filter(Boolean)
        .join('<br>')
    },
    async loadAll(period) {
      this.loadingAll = true

      this.allNotifications = await listAllNotifications(
        this.isOperatorUser
          ? this.$store.state.user.parentRef.id
          : this.$store.state.user.id,
        this.$store.state.user,
        period
      )

      this.loadAllNotifications = true
      this.operatorsListFlag = false
      this.loadingAll = false
    },
    openNotificationDetail(value) {
      // Para la navegacion:
      // idsInOrder: los ids en el orden en que los ve el usuario en el listado,
      // index: posicion actual
      let idsInOrder
      if (!this.userHasSorted) {
        // Si el usuario no ha reordenado el listado
        idsInOrder = this.filteredNotifications.map((n) => n.id)
      } else {
        // Si el usuario ha reordenado el listado,
        // v-data-table expone el array final renderizado, ordenado, filtrado, etc. como lo ve el usuario.
        // Nota: internalCurrentItems contiene los de la pagina actual (p.e. array de 25).
        // Para navegacion entre paginas hay que moverse de pagina.
        const table = this.$refs.dataTable
        if (!table || !Array.isArray(table.internalCurrentItems)) return

        const items = table.internalCurrentItems
        idsInOrder = items.map((n) => n.id)
      }

      const index = idsInOrder.indexOf(value.id)
      this.$store.commit('setNotificationNavigationContext', {
        ids: idsInOrder,
        index,
      })

      this.$router.push({
        name: 'NotificationDetailView',
        params: { id: value.id },
      })
    },
    async getNotification(notification) {
      //loop every item in main document (for zips)
      notification.document.items.forEach(async (doc) => {
        try {
          this.loadingData = true
          const response = this.$store.getters.isDemoEnv
            ? demoDocumentBase64()
            : await openNotification(notification, doc)

          const contentType = response.contentType || 'application/pdf'
          const blob = new Blob([Buffer.from(response.data, 'base64')], {
            type: contentType,
          })

          // Obtener la extensión usando la librería mime
          let extension = mime.extension(contentType)
          if (this.isRtf(contentType)) {
            extension = 'rtf' // Sobrescribir 'rtx' por 'rtf' que es lo que parece ser que usan los clientes en sus zip
          }
          saveAs(blob, `document_${doc['#Id']}.${extension}`)
          //saveAs(blob, doc.nombre) //TODO: Para el futuro si el DMS de Addalia lo acaben guardando
          this.loadingData = false
        } catch (err) {
          this.loadingData = false
          const message = getErrorText(err.toString())
          this.setSnackbar({
            position: 'top',
            type: 'error',
            message,
          })
        }
      })
    },
    async getAck(notification) {
      try {
        this.loadingData = true
        const response = this.$store.getters.isDemoEnv
          ? demoAckBase64()
          : await openAck(notification)

        const blob = new Blob([Buffer.from(response, 'base64')], {
          type: 'application/pdf',
        })
        saveAs(blob, `Acuse_${notification.id}.pdf`)

        this.loadingData = false
      } catch (err) {
        this.loadingData = false
        const message = getErrorText(err.toString())
        this.setSnackbar({
          position: 'top',
          type: 'error',
          message,
        })
      }
    },
    async getAnnexe(notification, annexe) {
      try {
        this.loadingData = true
        const response = this.$store.getters.isDemoEnv
          ? demoAnnexeBase64()
          : await openAnnexe(notification, annexe) // Annexe objeto completo del anexo seleccionado
        const blob = new Blob([Buffer.from(response, 'base64')], {
          type: annexe['Mime-Type'],
        })
        saveAs(blob, annexe.nombre)

        this.loadingData = false
      } catch (err) {
        const message = getErrorText(err.toString())
        this.setSnackbar({
          position: 'top',
          type: 'error',
          message,
        })
        this.loadingData = false
      }
    },
    optionsChange(options) {
      if (!options || !options.page || !options.itemsPerPage) return

      this.setNotificationsListOptions({
        page: options.page,
        itemsPerPage: options.itemsPerPage,
        sortBy: options.sortBy,
        sortDesc: options.sortDesc,
      })

      const optionsSaved = this.$store.state.notificationsListOptions
      if (optionsSaved) {
        this.options = {
          ...this.options,
          ...optionsSaved,
        }
      }
    },
    goToPage() {
      let page = Number(this.pageInput)

      if (isNaN(page)) page = this.options.page

      // Validamos que esté entre 1 y el total de paginas
      page = Math.max(1, Math.min(page, this.totalPages))

      this.pageInput = page
      this.options.page = page

      // Despues de que el usuario pulse Enter, quitamos el foco del input
      this.$nextTick(() => {
        document.activeElement?.blur()
      })
    },
    searchChange(search) {
      this.setNotificationsSearch(search ? search : '') //If clearable, store empty string instead of null
    },
    updateNotifications() {
      updateNotifications(true)
    },
    async exportNotifications() {
      var exportedNotifications = this.filteredNotifications.map(
        (notification) => {
          /*const processHistory = (history) => {
            const actionTypes = ['mailSystem', 'NoMailSystem'] // Tipos de acción a incluir

            const result = []

            history.forEach((item) => {
              const { subject, actionType, emails = '', noemails = '' } = item

              // Filtrar por actionType permitido
              if (!actionTypes.includes(actionType)) {
                return
              }

              // Buscar si ya existe un elemento con el mismo subject
              const existingSubject = result.find(
                (entry) => entry.subject === subject
              )

              if (!existingSubject) {
                // Si no existe, creamos uno nuevo
                result.push({
                  subject,
                  emails: actionType === 'NoMailSystem' ? '' : emails,
                  noemails: actionType === 'NoMailSystem' ? noemails : noemails,
                })
              } else {
                // Si ya existe, concatenamos/sumamos los valores
                if (actionType === 'NoMailSystem') {
                  if (!existingSubject.noemails.includes(emails))
                    existingSubject.noemails = [
                      existingSubject.noemails,
                      emails,
                    ]
                      .filter(Boolean) // Filtra valores no vacíos
                      .join(',')
                } else {
                  if (!existingSubject.emails.includes(emails))
                    existingSubject.emails = [existingSubject.emails, emails]
                      .filter(Boolean) // Filtra valores no vacíos
                      .join(',')
                  if (!existingSubject.noemails.includes(noemails))
                    existingSubject.noemails = [
                      existingSubject.noemails,
                      noemails,
                    ]
                      .filter(Boolean) // Filtra valores no vacíos
                      .join(',')
                }
              }
            })
            return result
          }*/
          let mappedNotification = {
            ref: notification.ref.path,
            identificador: notification.identificador,
            estado: notification.estado,
            concepto: notification.concepto,
            fecha_puesta_disposicion:
              notification.fecha_puesta_disposicion.toLocaleDateString(
                this.$i18n.locale,
                {
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                  hour: 'numeric',
                  minute: 'numeric',
                }
              ),
            fecha_aceptacion: notification.fecha_aceptacion
              ? notification.fecha_aceptacion.toLocaleDateString(
                  this.$i18n.locale,
                  {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                  }
                )
              : '',
            nif_titular: notification.nif_titular,
            nombre_titular: notification.nombre_titular,
            nif_peticion: notification.nif_peticion,
            nombre_organismo_emisor: notification.nombre_organismo_emisor,
            codigo_organismo_emisor: notification.codigo_organismo_emisor,
            nombre_organismo_emisor_raiz:
              notification.nombre_organismo_emisor_raiz,
            codigo_organismo_emisor_raiz:
              notification.codigo_organismo_emisor_raiz,
          }
          if (this.operatorsListFlag) {
            mappedNotification.operadores_con_visibilidad_numero =
              notification.operators.length

            mappedNotification.operadores_con_visibilidad_nombres =
              notification.operators.map((operator) => operator.name).join(', ')
          }
          /*if (includeMails)
            mappedNotification.mails = processHistory(notification.history)*/

          return mappedNotification
        }
      )
      if (exportedNotifications.length < 1) {
        const message = this.$t('nothingToExport')
        this.setSnackbar({ position: 'top', type: 'info', message })
        return
      }
      const replacer = (key, value) => (value === null ? '' : value) // valores undefined
      /*const getUniqueSubjects = (exportNotifications) => {
        const subjectMap = new Map()

        exportNotifications.forEach((notification) => {
          notification.mails.forEach((mail) => {
            const { subject } = mail

            // Si el subject no está en el mapa, lo añadimos
            if (!subjectMap.has(subject)) {
              subjectMap.set(subject, true)
            }
          })
        })

        // Convertimos las claves del mapa en un array
        return Array.from(subjectMap.keys())
      }*/

      //header auxiliar csv con el nombre de las variables
      const header = [
        'identificador',
        'estado',
        'concepto',
        'fecha_puesta_disposicion',
        'fecha_aceptacion',
        'nif_titular',
        'nombre_titular',
        'nif_peticion',
        'nombre_organismo_emisor',
        'codigo_organismo_emisor',
        'nombre_organismo_emisor_raiz',
        'codigo_organismo_emisor_raiz',
      ]
      //header a mostrar en el csv
      const header2 = [
        this.$i18n.t('csv.notifications.identificador'),
        this.$i18n.t('csv.notifications.estado'),
        this.$i18n.t('csv.notifications.concepto'),
        this.$i18n.t('csv.notifications.fecha_puesta_disposicion'),
        this.$i18n.t('csv.notifications.fecha_aceptacion'),
        this.$i18n.t('csv.notifications.nif_titular'),
        this.$i18n.t('csv.notifications.nombre_titular'),
        this.$i18n.t('csv.notifications.nif_peticion'),
        this.$i18n.t('csv.notifications.nombre_organismo_emisor'),
        this.$i18n.t('csv.notifications.codigo_organismo_emisor'),
        this.$i18n.t('csv.notifications.nombre_organismo_emisor_raiz'),
        this.$i18n.t('csv.notifications.codigo_organismo_emisor_raiz'),
      ]

      if (this.operatorsListFlag) {
        header.push(
          'operadores_con_visibilidad_numero',
          'operadores_con_visibilidad_nombres'
        )
        header2.push(
          this.$i18n.t('csv.notifications.operadores_con_visibilidad_numero'),
          this.$i18n.t('csv.notifications.operadores_con_visibilidad_nombres')
        )
      }

      /*if (includeMails)
        getUniqueSubjects(exportNotifications).forEach((subject) => {
          if (!header.includes(subject)) {
            header.push(subject)
            header2.push(subject)
          }
        })*/

      /*const csv = [
        header2.join(';'), // asignamos separador
        ...exportNotifications.map((row) =>
          header
            .map((fieldName) => JSON.stringify(row[fieldName], replacer))
            .join(';')
        ),
      ].join('\r\n')*/

      if (this.includeMails) {
        const firebaseUser = await Auth.getAuth().currentUser
        await NotificationsExportCSV({
          auth: firebaseUser.getIdToken(),
          notifications: exportedNotifications,
          operatorsListFlag: this.operatorsListFlag,
          user: this.$store.state.user.id,
        })
        this.includeMails = false
        const message = this.$t('exportScheduled')
        this.setSnackbar({ position: 'top', type: 'success', message })
        return
      }
      const csv = [
        header2.join(';'), // asignamos separador
        ...exportedNotifications.map((row) =>
          header
            .map((fieldName) => {
              // Comprobar si el fieldName coincide con algún subject en mails
              return JSON.stringify(row[fieldName], replacer)
              /*let mailEntry
              if (includeMails) {
                mailEntry = row.mails.find((mail) => mail.subject === fieldName)
              } else {
                mailEntry = false
              }

              if (mailEntry) {
                // Si coincide, construimos el string con enviados/no enviados
                return JSON.stringify(
                  `enviados: ${mailEntry.emails || ''} - no enviados: ${
                    mailEntry.noemails || ''
                  }`
                )
              } else {
                // Si no coincide, devolver el valor del campo normal
                return JSON.stringify(row[fieldName], replacer)
              }*/
            })
            .join(';')
        ),
      ].join('\r\n')

      // Creamos elemento html
      const link = document.createElement('a')
      // Creamos el objeto blob con el contenido deseado (el array de objetos pasado a cadena de texto en formato csv)
      const file = new Blob([csv], { type: 'text/plain' })
      // añadimos el objeto a la url
      link.href = URL.createObjectURL(file)
      // le damos nombre
      link.download = 'notifications.csv'
      // Se descarga el objeto forzando un click en el elemento y eliminamos la url.
      link.click()
      URL.revokeObjectURL(link.href)
      const message = this.$t('exportComplete')
      this.setSnackbar({ position: 'top', type: 'success', message })
      this.includeMails = false
      return
    },
    async switchOperatorsListFlag() {
      if (!this.operatorsListFlag) {
        this.loadingData = true

        // refactor reducir consumo de memoria
        buildCifOperatorsIndex(this.operators)

        this.notificationsWithOperators = await operatorsCanViewNotification(
          this.operators,
          [...this.notifications]
        )

        this.loadingData = false
      }
      if (this.operatorsListFlag) {
        // al cerrar libera la memoria ocupada por la copia, si puede
        this.notificationsWithOperators = []
      }
      this.operatorsListFlag = !this.operatorsListFlag
    },
    buildCustomHeaders() {
      const auxCustomHeader = [
        {
          text: 'ID',
          align: 'start',
          sortable: false,
          value: 'id',
        },
        {
          text: this.$t('opers'),
          value: 'operators',
          width: '20px',
        },
        {
          text: this.$t('alert'),
          value: 'alert',
          sort: (a, b) =>
            a && b ? b.date - a.date : a && !b ? -1 : !a && b ? 1 : 0,
        },
        {
          text: this.$t('resp'),
          value: 'manager',
          width: '20px',
          /*sort: (a, b) =>
            a && b ? a.id.localeCompare(b.id) : a && !b ? -1 : !a && b ? 1 : 0,*/

          // sort corregido con soporte completo de idioma
          sort: (a, b) => {
            // 1. Ambos sin manager
            if (!a && !b) return 0

            // 2. Solo uno sin manager
            if (!a) return 1
            if (!b) return -1

            // 3. Normalización de nombre y apellido
            const aName = a.name || ''
            const bName = b.name || ''

            // ignora acentos (á === a), ignora mayúsculas/minúsculas (A === a),
            // trata correctamente la ñ como letra propia del español
            const nameCmp = aName.localeCompare(bName, 'es-ES', {
              sensitivity: 'base',
            })
            if (nameCmp !== 0) return nameCmp

            const aSurname = a.surname || ''
            const bSurname = b.surname || ''

            return aSurname.localeCompare(bSurname, 'es-ES', {
              sensitivity: 'base',
            })
          },
        },
        {
          text: this.$t('company'),
          value: 'nombre_titular',
          width: '40px',
        },
        { text: 'NIF', value: 'nif_titular' },
        {
          text: this.$t('dispatchDate'),
          value: 'fecha_puesta_disposicion',
          width: '20px',
        },
        { text: this.$t('state'), value: 'estado' },
        { text: this.$t('dateAcceptance'), value: 'fecha_aceptacion' },
        { text: this.$t('issuer'), value: 'concepto', width: '250px' },
        {
          text: this.$t('issuingAuthority'),
          value: 'nombre_organismo_emisor',
        },
        {
          text: this.$t('rootAuthority'),
          value: 'nombre_organismo_emisor_raiz',
        },
        { text: this.$t('notificationType'), value: 'tipo_envio' },
        { text: this.$t('content'), value: 'contenido', sortable: false },
      ]
      if (!this.operatorsListFlag) auxCustomHeader.splice(1, 1)
      return auxCustomHeader
    },
    closeGrid() {
      this.openGridNotifications = false
    },
    closeChangePeriodDialog() {
      this.changePeriodDialog = false
    },
    isEmptyNifTitular(item) {
      return !(item.nif_titular && item.nif_titular.trim().length > 0)
    },
    isIgnoredNifTitular(item) {
      return (
        item.nif_titular &&
        item.nif_titular === this.ignoreWordAlwaysInSpanish()
      )
    },
    isEmptyResponsible(item) {
      return !(item.managerRef && item.managerRef.id)
    },
    ignoreWordAlwaysInSpanish() {
      return this.$i18n.t('editNifDialog.ignoreWord', 'es') || 'IGNORAR'
    },
    isRtf(contentType) {
      return (
        contentType === 'text/richtext' || contentType === 'application/rtf'
      )
    },
    confirmExport() {
      this.dialogmails = false
      this.exportNotifications()
    },
    onCancel() {
      clearTimeout(this.loadingTimeout)
      this.loadingTimeout = null
      this.showLongLoadingModal = false
      this.$emit('setCancelLoad')
    },
    async setCurrentPeriod(newPeriod) {
      this.closeChangePeriodDialog()
      if (newPeriod) {
        // al seleccionar un periodo distinto al inicial se deben recargar los
        // atributos de grupos en cada notificacion mediante la llamada a loadGroupData que
        // disparara el watcher de notificaciones al detectar los cambios
        this.setNotificationsReloaded(true)

        // comprobar si hay que restaurar las notificaciones iniciales
        if (newPeriod.title == 'initialMode') {
          this.loadAllNotifications = false
          this.currentPeriod = null
          this.operatorsListFlag = false
          this.notifications
        } else {
          // comprobar si ha cambiado y el usuario no ha seleccionado el mismo que había
          if (!lodash.isEqual(newPeriod, this.currentPeriod)) {
            this.currentPeriod = newPeriod
            await this.loadAll(this.currentPeriod)
          }
        }

        this.setNotificationsCurrentPeriod(
          this.currentPeriod ? this.currentPeriod : '' // almacenar '' en lugar de null
        )
      } else {
        // aqui no voy a guardar en el store porque si viene un null desde el dialogo es debido
        // a que han salido pulsando el botón de Cancelar (que no significa limpiar).
      }
    },
    buildTextCurrentPeriod() {
      if (!this.currentPeriod) return
      let unit
      if (this.currentPeriod.amount == 1) {
        if (this.currentPeriod.unit == 'months') unit = 'month'
        if (this.currentPeriod.unit == 'years') unit = 'year'
        if (this.currentPeriod.unit == 'days') unit = 'day'
      } else {
        unit = this.currentPeriod.unit
      }

      if (unit == 'dateRange') {
        if (this.currentPeriod.initialDate && this.currentPeriod.finalDate) {
          return (
            this.$t('periods.period') +
            ' ' +
            this.$d(new Date(this.currentPeriod.initialDate), 'i18nDate') +
            ' - ' +
            this.$d(new Date(this.currentPeriod.finalDate), 'i18nDate')
          )
        } else {
          return this.$t('periods.' + this.currentPeriod.title)
        }
      } else {
        return this.$t('periods.' + this.currentPeriod.title, {
          amount: this.currentPeriod.amount,
          unit: this.$t('periods.' + unit),
        })
      }
    },
    async setCurrentAdvancedSearch(newAdvancedSearch) {
      this.closeAdvancedSearchDialog()
      if (newAdvancedSearch) {
        // comprobar si ha cambiado y el usuario no ha seleccionado el mismo que había
        if (!lodash.isEqual(newAdvancedSearch, this.currentAdvancedSearch)) {
          this.currentAdvancedSearch = newAdvancedSearch
        }
      } else {
        this.currentAdvancedSearch = null
      }

      this.setNotificationsAdvancedSearch(
        newAdvancedSearch ? newAdvancedSearch : '' // almacenar '' en lugar de null
      )
    },
    closeAdvancedSearchDialog() {
      this.advancedSearchDialog = false
    },
    getStatusList() {
      return buildStatusList()
    },
    getAlertStatusList() {
      return buildAlertStatusList()
    },
    tooltipAdvancedSearchButton() {
      // Mostrar en un tooltip multilinea el estado de la busqueda avanzada
      const tooltipAdvancedSearchLine1 = this.$t(
        'searches.tooltipAdvancedSearchButtonLine1'
      )
      const tooltipAdvancedSearchLine2 = this.$t(
        'searches.tooltipAdvancedSearchButtonLine2',
        {
          status: this.currentAdvancedSearch
            ? this.$t('searches.active')
            : this.$t('searches.inactive'),
        }
      )

      // Unir las lineas con saltos de linea para mostrar un tooltip multilinea
      const message = `${tooltipAdvancedSearchLine1}<br>${tooltipAdvancedSearchLine2}`
      return message
    },
    /**
     * Concatena para posteriormente poder buscar indistintamente en el atributo concepto y
     * en el atributo conceptoXML del array de los metadatas, si es que existe.
     */
    joinConcepts(doc) {
      const conceptoXML = doc.metadatas?.find((m) => m.conceptoXML)?.conceptoXML
      return conceptoXML ? `${doc.concepto} - ${conceptoXML}` : doc.concepto
    },
    isTitularOriginalModificado(item) {
      // Si el atributo existe y vale '1', entonces está modificado
      return item?.titular_original_modificado === '1'
    },
    getTitularOriginalTooltip(item) {
      // Devuelve el texto del tooltip cuando el titular ha sido modificado
      const tooltipLine1 = this.$t('originalNifTitularLine1')
      const tooltipLine2 = this.$t('originalNifTitularLine2', {
        titularOriginalNif: item?.titular_original_nif,
      })
      const tooltipLine3 = this.$t('originalNifTitularLine3', {
        titularOriginalNombre: item?.titular_original_nombre,
      })

      // Unir las lineas con saltos de linea para mostrar un tooltip multilinea
      const message = `${tooltipLine1}<br>${tooltipLine2}<br>${tooltipLine3}`
      return message
    },
    fullName(obj, nameKey = 'name', surnameKey = 'surname') {
      if (!obj) return ''
      if (obj.fullName) return obj.fullName

      return [obj[nameKey], obj[surnameKey]]
        .filter((value) => typeof value === 'string' && value.trim() !== '')
        .join(' ')
    },
    isGroup(ref) {
      return isGroupRef(ref)
    },
    async canOperatorAccessToNotification(operator, notification) {
      // Segun las especificaciones de la tarea GOODOK-2039 si el responsable es un grupo y el operador
      // pertenece a ese grupo debe tomar en cuenta solo las empresas, y no aplicar tambien los filtros.
      const canBeManager = this.isGroup(notification.managerRef)
        ? canOperatorBeManager(withHeavyCache(operator), notification)
        : await canOperatorBeManagerWithFilters(
            withHeavyCache(operator),
            notification
          )

      return canBeManager && !operator.disabled
    },
    async loadGroupData(
      item,
      { forceReset = false, showLoading = false } = {}
    ) {
      if (!item.managerRef) {
        item.overlapIconColor = undefined
        return
      }

      // Bloqueo por item, evitar concurrencias
      if (item._loadingGroupData) return

      if (this.isGroup(item.managerRef)) {
        if (!item._groupState) {
          this.$set(item, '_groupState', {
            loading: false,
            operatorsLoaded: false,
            tooltipReady: false,
            accessReady: false,
          })
        }

        this.$set(item, '_loadingGroupData', true)
        item._groupState.loading = true
        item._groupState.tooltipReady = false
      }

      if (!item.overlapIconColor) {
        this.$set(item, 'overlapIconColor', 'loading')
      }

      try {
        // En el reproceso mostrar el icono loading
        if (!forceReset && showLoading) {
          ////this.$set(item, 'isReprocessing', true)
        }

        if (!this.isGroup(item.managerRef)) {
          // Añadir nueva propiedad reactiva solo para los usuarios, no grupos
          this.$set(item, 'canBeManager', null)

          // La notificacion tiene un responsable operador, no un grupo.
          // Puede haber algun caso en el que el operador este disabled (ya contemplado), pero tambien puede
          // ocurrir que al operador asignado le quiten la empresa y deje de ver la notificacion, en cuyo caso
          // hay que mostrar, a los usuarios admin, un triangulo rojo en el avatar del responsable.
          const operator =
            this.operatorsMap[item.managerRef.id] ??
            (await GetDocumentFromReference(item.managerRef))

          item.canBeManager = canOperatorBeManager(
            withHeavyCache(operator),
            item
          )
          this.updateOverlapIconColor(item) // Estado del avatar del operador
          return
        }

        // Es un Grupo
        // Si ya esta cargado volver a calcular los permisos igualmente, no guardar nada en cache
        // Estado inicial, aun no cargado (reactivo)
        if (forceReset) {
          item._groupState.operatorsLoaded = false
        }

        try {
          // Calcular el acceso a la notificacion
          await this.loadGroupOperatorsAccess(item)

          item._groupState.operatorsLoaded = true
          item._groupState.tooltipReady = true
          item._groupState.loading = false

          if (!this.getGroupOperators(item).length) {
            this.$set(item, 'groupAccess', {
              status: 'ready',
              map: {},
              summary: {
                hasAnyAccess: false,
                hasPending: false,
                rejectedAll: true,
              },
            })
            item.overlapIconColor = 'error'
            return
          }

          this.updateOverlapIconColor(item) // Estado del avatar del grupo
        } catch (e) {
          console.error(
            'Item id: ' +
              item.id +
              ' , Error cargando accesos de los operadores del grupo: ',
            this.groupsOperatorsMap[item.managerRef.id]?.name,
            e
          )
          item._groupState.operatorsLoaded = true
          item._groupState.tooltipReady = true
          item._groupState.loading = false
          item.overlapIconColor = 'error'
        }
      } finally {
        item._loadingGroupData = false
      }
    },
    async loadGroupOperatorsAccess(item) {
      if (!item.managerRef) return
      if (!this.isGroup(item.managerRef)) return

      const entry = this.groupsOperatorsMap[item.managerRef.id]
      // grupos todavia no cargados en el mapa
      if (!entry) {
        return
      }
      const operatorIds = entry?.operatorIds ?? []
      const operators = operatorIds
        .map((id) => this.operatorsMap[id])
        .filter(Boolean)

      // limpiar e iniciar loading
      if (!item.groupAccess) {
        this.$set(item, 'groupAccess', {
          status: 'loading',
          map: {},
          summary: {},
        })
      }

      /* INFORMACION
       * Nuevo objeto ligero en cada notificacion, se define como sigue:
       * groupAccess = {
       *    status: puede ser 'loading' | 'ready' | 'error',
       *    map: [operatorId]
       *      { canAccess: boolean,
       *        hasError: boolean,
       *        response: {
       *          responded: boolean,
       *          accepted: boolean | null,
       *          lastResponseAt: timestamp | null,
       *          color,
       *          text,
       *        }
       *    },
       *    summary: {
       *      eligibleCount,
       *      hasAnyAccess,
       *      hasPending,
       *      rejectedAll,
       *      acceptedOperatorDeletedFromGroup,
       *      acceptedOperatorDeletedFromGroupFullname,
       *      lastAcceptedStillValid
       *      hasAccepted
       *    }
       * }
       *
       */

      try {
        const accessMap = {}
        // 1. acceso por operador
        // Procesado secuencial (no Promise.all)
        const responses = item?.responseOperators || []
        const responsesByOperator = {}

        for (const r of responses) {
          const prev = responsesByOperator[r.userRef.id]

          if (!prev || r.createdAt > prev.createdAt) {
            responsesByOperator[r.userRef.id] = {
              response: r.response,
              createdAt: r.createdAt,
            }
          }
        }

        for (const operator of operators) {
          const canAccess = await this.canOperatorAccessToNotification(
            operator,
            item
          )

          const responseInfo = responsesByOperator[operator.id] || null

          let color = ''
          if (operator.disabled) {
            color = ''
          } else if (responseInfo) {
            color = responseInfo.response === false ? 'error' : 'success'
          }

          let text = ''
          if (responseInfo) {
            if (responseInfo.response === false) {
              text = this.$t('operatorResponsabilityRejected')
            } else if (responseInfo.response === true) {
              text = this.$t('operatorResponsabilityAccepted')
            }

            if (responseInfo.createdAt) {
              // esta almacenada en milisegundos
              text += ' (' + this.formatDate(responseInfo.createdAt) + ')'
            }
          }

          accessMap[operator.id] = {
            canAccess,
            hasError: operator.disabled || canAccess !== true,
            response: {
              responded: !!responseInfo,
              accepted: responseInfo ? responseInfo.response : null,
              lastResponseAt: responseInfo ? responseInfo.createdAt : null,
              color,
              text,
            },
          }
        }

        // 2. elegibles, son lo que pueden acceder
        const eligibleOperators = operators.filter(
          (op) => !op.disabled && accessMap[op.id].canAccess === true
        )

        const eligibleCount = eligibleOperators.length

        // 3. pendientes
        const respondedIds = responses.map((r) => r.userRef.id)
        const hasPending = eligibleOperators.some(
          (op) => !respondedIds.includes(op.id)
        )

        // 4. rechazados globales
        const rejectedAll =
          eligibleOperators.length > 0 &&
          eligibleOperators.every((op) =>
            responses.some(
              (r) => r.userRef.id === op.id && r.response === false
            )
          )

        // 5. ultimo aceptado
        const acceptedOperators = responses
          .filter((r) => r.response === true)
          .sort((a, b) => b.createdAt - a.createdAt)

        let acceptedOperatorDeletedFromGroup = false
        let acceptedOperatorDeletedFromGroupFullname = ''
        let lastAcceptedStillValid = false

        if (acceptedOperators.length > 0) {
          const lastAccepted = acceptedOperators[0]

          const stillInGroup = operators.some(
            (op) => op.id === lastAccepted.userRef.id
          )

          acceptedOperatorDeletedFromGroup = !stillInGroup

          // Guardar el nombre del operador que aceptó y que ya no se encuentra en el grupo, para mostrarlo en el tooltip
          if (!stillInGroup) {
            const oper = this.operators.find(
              (op) => op.id === lastAccepted.userRef.id
            )

            if (oper) {
              acceptedOperatorDeletedFromGroupFullname = this.fullName(oper)
            }
          }

          const accessOk = stillInGroup
            ? accessMap[lastAccepted.userRef.id].canAccess
            : false

          lastAcceptedStillValid = stillInGroup && accessOk
        }

        // hay alguien que tenga acceso ?
        const hasAnyAccess = eligibleOperators.length > 0

        // 6. commit final (una sola mutación reactiva)
        this.$set(item, 'groupAccess', {
          status: 'ready',
          map: accessMap,
          summary: {
            eligibleCount,
            hasAnyAccess,
            hasPending,
            rejectedAll,
            acceptedOperatorDeletedFromGroup,
            acceptedOperatorDeletedFromGroupFullname,
            lastAcceptedStillValid,
            hasAccepted: acceptedOperators.length > 0,
          },
        })
      } catch (e) {
        console.error('Error comprobando accesos del grupo', e)

        this.$set(item, 'groupAccess', {
          status: 'error',
          map: null,
          summary: null,
        })
      }
    },
    operatorAccessText(operator, item) {
      const groupAccess = item.groupAccess

      // estado del grupo
      if (!groupAccess || groupAccess.status === 'loading') {
        return this.$t('processing')
      }

      if (groupAccess.status === 'error') {
        return this.$t('operatorAccessNotificationKO')
      }

      if (operator.disabled) return this.$t('operatorDisabled')

      const canAccess = groupAccess.map?.[operator.id]?.canAccess
      return canAccess
        ? '' //this.$t('operatorAccessNotificationOK') // por defecto, si tiene acceso no pinta ningun texto
        : this.$t('operatorAccessNotificationKO')
    },
    onActivatorMouseEnter(e, item, on) {
      on.mouseenter(e) // asegura que Vuetify abra el tooltip
    },
    calculateOverlapIconColor(item) {
      if (!item.manager) return undefined

      // Si no es grupo, comportamiento normal de usuario
      if (!this.isGroup(item.managerRef)) {
        return item.manager?.disabled || item.canBeManager === false
          ? 'error'
          : !item.managerAccepted
          ? 'warning'
          : undefined
      }

      // Es un grupo, pero esta eliminado
      if (item.manager.deleted) return 'error'

      const groupAccess = item.groupAccess

      // Mientras se carga cualquier cosa del grupo: muestra el spinner
      if (!groupAccess || groupAccess.status !== 'ready') {
        return 'loading'
      }

      const operators = this.getGroupOperators(item)

      if (!operators.length) {
        return 'error'
      }

      const s = groupAccess.summary
      if (!s) return 'loading'

      // Nadie puede acceder
      if (!s.hasAnyAccess) return 'error'

      // Aceptó alguien y sigue siendo valido: ok, sin icono
      if (s.hasAccepted && s.lastAcceptedStillValid) {
        return undefined
      }

      // Aceptó alguien pero ya no es valido
      if (s.hasAccepted && !s.lastAcceptedStillValid) {
        return 'error'
      }

      // Hay pendientes
      if (s.hasPending) {
        return 'warning'
      }

      // Caso final: nadie pendiente y nadie aceptado valido
      return 'error'
    },
    getLatestOperatorResponse(notification, operator) {
      return this.getOperatorResponses(notification, operator)?.latest ?? null
    },
    getOperatorResponses(notification, operator) {
      // ahora un operador puede tener mas de una respuesta (p.e. rechazar y despues aceptar)
      // devuelve el objeto con la info necesaria: quién, qué y cuándo
      if (!notification.responseOperators?.length) {
        return { latest: null, history: [] }
      }

      const responses = notification.responseOperators
        .filter((r) => r.userRef.id === operator.id)
        .slice() // copia defensiva, evita mutar el array original
        .sort((a, b) => b.createdAt - a.createdAt) // mas reciente arriba

      return {
        latest: responses[0] ?? null,
        history: responses.slice(1),
      }
    },
    formatDate(ts) {
      if (!ts) return ''
      const d = new Date(ts)
      const pad = (n) => String(n).padStart(2, '0')

      return (
        `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ` +
        //`${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
        `${pad(d.getHours())}:${pad(d.getMinutes())}`
      )
    },
    hasGroupChanged(prev, curr) {
      if (prev.name !== curr.name) return true
      if (prev.deleted !== curr.deleted) return true

      if (
        JSON.stringify(this.normalizeArray(prev.cifsRef)) !==
        JSON.stringify(this.normalizeArray(curr.cifsRef))
      )
        return true

      if (
        JSON.stringify(this.normalizeArray(prev.filtersRef)) !==
        JSON.stringify(this.normalizeArray(curr.filtersRef))
      )
        return true

      if (
        JSON.stringify(this.normalizeArray(prev.usersRef)) !==
        JSON.stringify(this.normalizeArray(curr.usersRef))
      )
        return true

      return false
    },
    normalizeArray(arr) {
      // Normaliza los arrays de referencias:
      // - Extrae id si es una referencia
      // - Ordena para evitar cambios de orden irrelevantes
      if (!Array.isArray(arr)) return []
      return arr.map((item) => item?.id ?? item).sort()
    },
    updateOverlapIconColor(item) {
      const color = this.calculateOverlapIconColor(item)
      if (item.overlapIconColor !== color) {
        this.$set(item, 'overlapIconColor', color)
      }
    },
    getGroupOperators(item) {
      if (!item?.managerRef || !this.isGroup(item.managerRef)) return []

      const entry = this.groupsOperatorsMap[item.managerRef.id]
      if (!entry?.operatorIds?.length) return []

      return entry.operatorIds
        .map((id) => this.operatorsMap[id])
        .filter(Boolean)
    },
    getGroupOperatorsPreview(item) {
      const operators = this.getGroupOperators(item)
      // primero ordenar y luego hacer el slice
      return this.sortOperatorsByFullName(operators).slice(
        0,
        this.maxOperatorsPreview
      )
    },
    sortOperatorsByFullName(operators = []) {
      // ordenar por nombre, sin mutar el array original.
      return [...operators].sort((a, b) =>
        a.fullName.localeCompare(b.fullName, 'es', { sensitivity: 'base' })
      )
    },
    rowClass(item) {
      // Identifica pos css la fila que contiene la ultima notificacion visitada
      if (item.id === this.lastVisitedId) {
        if (!this.hasScrolledToLastVisited) {
          // y ademas es el momento justo para llamar a la funcion de scroll en lugar de un timeout o un watcher
          this.hasScrolledToLastVisited = true
          this.$nextTick(() => {
            this.scrollToLastVisitedRow()
          })
        }

        return 'last-visited-row'
      }
      return ''
    },
    scrollToLastVisitedRow() {
      // localiza la fila que ha sido identificada por css
      const row = this.$el.querySelector('.last-visited-row')

      // si la encuentras, haz scroll hasta ella y muestrala centrada verticalmente
      // además la clase css la mostrará con una animacion de color
      row?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })
    },
  },
  computed: {
    ...mapGetters([
      'isMobile',
      'isAdminUser',
      'isOperatorUser',
      'isColectivoUser',
      'isTermsAccepted',
      'isSuperAdminUser',
      'isSuperOperatorUser',
      'isUpdatingNotifications',
      'maxOperatorsPreview',
      'isAdminAndCanManageCompanies',
      'isInGroupUser',
      'isAdminAndCanManageGroups',
    ]),
    notifications() {
      if (this.operatorsListFlag) {
        return this.notificationsWithOperators
      }
      return this.loadAllNotifications
        ? this.allNotifications
        : this.$store.state.notifications
    },
    headers() {
      return this.isMobile
        ? [
            { text: this.$t('company'), value: 'nombre_titular' },
            { text: 'NIF', value: 'nif_titular' },
            { text: this.$t('issuer'), value: 'concepto', width: '300px' },
            { text: this.$t('state'), value: 'estado' },
          ]
        : this.buildCustomHeaders()
    },
    notificationsWithoutNifTitularCount() {
      const filtered = this.filteredNotifications
      if (!filtered) return 0
      const count = filtered.reduce((count, item) => {
        return this.isEmptyNifTitular(item) ? count + 1 : count
      }, 0)
      return count
    },
    notificationsWithoutNifTitular() {
      return this.notifications.filter((notification) => {
        return this.isEmptyNifTitular(notification)
      })
    },
    filteredNotifications() {
      if (!this.notifications.length) return []
      const filtered = this.notifications.filter((item) => {
        // los superadmin y los operadores con permisos de admin deben poder ver las notificaciones sin nif titular.
        if (
          (this.isSuperAdminUser || this.isSuperOperatorUser) &&
          !item.nif_titular
        )
          return true

        // Ignorar las que no pertenezcan a mi empresas cargadas (borradas, no asignadas a mi operador)
        const inLoaded = this.loadedCifs.some(
          (cif) =>
            cif.numeroDocIdentidad === item.nif_titular ||
            cif.numeroDocIdentidad === item.nif_peticion
        )

        // Si no está en loadedCifs, miramos si está en alternativeCertificates en caso de que:
        // - nif_titular no existe o está vacío,
        // - nif_titular se haya establecido previamente en IGNORAR,
        // - y en ese caso solo comparamos contra nif_peticion
        if (
          !inLoaded &&
          (this.isEmptyNifTitular(item) || this.isIgnoredNifTitular(item))
        ) {
          const alternatives =
            this.$store.state.user?.alternativeCertificates || []
          const inAlternative = alternatives.some(
            (certificate) =>
              certificate.numeroDocIdentidad === item.nif_peticion
          )
          // Si tampoco está en alternative, lo descartamos y no aparecerá en el listado
          if (!inAlternative) return false
        }

        //
        // No mostrar las notificaciones que pertenezcan a una empresa encolada para ser borrada.
        if (this.loadedCifsList.length) {
          const nifTitularFound = this.loadedCifsList.find(
            (c) => c.numeroDocIdentidad === item.nif_titular
          )

          if (
            inLoaded &&
            item.nif_titular &&
            nifTitularFound &&
            (!nifTitularFound?.notificacionesActivas ||
              nifTitularFound?.deletionDate)
          ) {
            //console.log(
            //  `Notificacion: ${item.id} excluida , nif_titular: ${item.nif_titular} , notificacionesActivas: ${nifTitularFound.notificacionesActivas} , deletionDate: ${nifTitularFound.deletionDate}`
            //)
            return false
          }
        }

        // Optimización de codigo: si no hay una búsqueda activa se incluye el documento
        if (!this.search || this.searchTerms?.length === 0) {
          return true
        }

        const {
          codigo_organismo_emisor,
          codigo_organismo_emisor_raiz,
          concepto,
          fecha_puesta_disposicion,
          fecha_aceptacion,
          id,
          identificador,
          nif_titular,
          nombre_organismo_emisor,
          nombre_organismo_emisor_raiz,
          nombre_titular,
          tipo_envio,
          manager,
          alert,
          ref,
          titular_original_modificado,
          titular_original_nif,
          titular_original_nombre,
        } = item

        // Guardamos los elementos en mayúscula
        let dataCap = [
          this.$t(getNotificationStatus(item).status).toUpperCase(),
          codigo_organismo_emisor?.toUpperCase(),
          codigo_organismo_emisor_raiz?.toUpperCase(),
          concepto?.toUpperCase(),
          this.$d(fecha_puesta_disposicion, 'i18nDate').toUpperCase(),
          fecha_aceptacion
            ? this.$d(fecha_aceptacion, 'i18nDate').toUpperCase()
            : '',
          id?.toUpperCase(),
          identificador?.toUpperCase(),
          nif_titular?.toUpperCase(),
          nombre_organismo_emisor?.toUpperCase(),
          nombre_organismo_emisor_raiz?.toUpperCase(),
          nombre_titular?.toUpperCase(),
          this.$t(getNotificationType({ tipo_envio }).name).toUpperCase(),
          ref,
          titular_original_modificado ? titular_original_modificado : '',
          titular_original_nif?.toUpperCase(),
          titular_original_nombre?.toUpperCase(),
        ]

        // Si hay elementos de manager los guardamos en la lista (email todo lo anterior a @)
        const managerData = manager
          ? [
              manager.email?.split('@')[0].toUpperCase(),
              this.fullName(manager).toUpperCase(),
            ]
          : false
        if (managerData) dataCap = [...dataCap, ...managerData]

        // Si hay elementos de alerta los guardamos en la lista
        const alertData = alert
          ? [
              this.$d(alert.date, 'i18nDate').toUpperCase(),
              alert.text.toUpperCase(),
            ]
          : false
        if (alertData) dataCap = [...dataCap, ...alertData]

        // filtramos y normalizamos todos los atributos de tipo string para eliminar acentos
        dataCap = dataCap
          .filter((val) => typeof val === 'string' && val.length > 0)
          .map(normalizeSearch)

        // Comprueba si alguno de los campos contiene alguno de los términos de búsqueda,
        // optimizado porque se detiene en el primero que encuentre y no continua buscando.
        return dataCap.some((field) =>
          this.searchTerms.some((term) => field.includes(term))
        )
      })

      // ----
      // Segunda parte, añadir el filtrado de las búsquedas avanzadas, si hay.
      if (!this.currentAdvancedSearch) return filtered

      // Filtrar segun criterios de búsqueda avanzada
      const {
        selectedCifs,
        cifsNotRegisteredShowAll,
        cifsNotRegistered,
        withoutNifTitular,
        ignoreNifTitular,
        selectedStatus,
        selectedFilters,
        customFilter,
        codigo_organismo_emisor,
        nombre_organismo_emisor,
        codigo_organismo_emisor_raiz,
        nombre_organismo_emisor_raiz,
        concepto,
        tipo_envio,
        selectedUsers,
        selectedGroups,
        withoutResponsible,
        selectedAlertStatus,
        alertInitialDate,
        alertFinalDate,
        alertText,
        observation,
        metadatas,
      } = this.currentAdvancedSearch

      let advancedSearchFiltered = filtered

      // * Nota, para atributos de tipo array creamos un Set para búsquedas O(1).
      // - Búsqueda ultra-rápida (set.has(x) es O(1)) frente a array.includes(x) que es O(n).
      // - Se nota en miles de documentos: filtrar decenas de miles pasa de tardar cientos de milisegundos a unos pocos.
      //
      // 1) Filtrar por Cifs seleccionados
      if (Array.isArray(selectedCifs) && selectedCifs.length) {
        const cifSet = new Set(selectedCifs)
        advancedSearchFiltered = advancedSearchFiltered.filter((item) => {
          const inSelected = cifSet.has(item.nif_titular)

          // Si no está en selectedCifs, miramos si es un caso especial y si esta marcado su checkbox:
          // - nif_titular no existe o está vacío,
          // - nif_titular se haya establecido previamente en IGNORAR,
          if (
            !inSelected &&
            ((this.isEmptyNifTitular(item) && withoutNifTitular) ||
              (this.isIgnoredNifTitular(item) && ignoreNifTitular))
          ) {
            return true
          }

          // Si no es un caso especial que ya haya sido incluido
          return inSelected
        })
      }

      // 2) 'withoutNifTitular': si es false filtramos las notificaciones con el nif_titular vacio
      if (!withoutNifTitular) {
        advancedSearchFiltered = advancedSearchFiltered.filter(
          (item) => this.isEmptyNifTitular(item) === withoutNifTitular
        )
      }

      // 3) 'ignoreNifTitular': si es false filtramos las notificaciones con el nif_titular establecido a IGNORAR
      if (!ignoreNifTitular) {
        advancedSearchFiltered = advancedSearchFiltered.filter(
          (item) => this.isIgnoredNifTitular(item) !== true
        )
      }

      // 4) Estados: filtrar por estados seleccionados
      if (Array.isArray(selectedStatus) && selectedStatus.length) {
        const statusSet = new Set(selectedStatus)
        advancedSearchFiltered = advancedSearchFiltered.filter((item) =>
          statusSet.has(item.estado)
        )
      }

      // 5) Filtros: filtrar por los filtros seleccionados
      if (Array.isArray(selectedFilters) && selectedFilters.length) {
        //const filterSet = new Set(selectedFilters)  // aqui no es tan sencillo, de hecho es bastante complejo ...
        // copiada la logica desde notification-service
        advancedSearchFiltered = advancedSearchFiltered.filter((item) => {
          if (this.isOperatorUser) {
            // En caso de que sea el responsable de la notificación, incluirlo sin comprobar los filtros.
            if (
              item.managerRef &&
              item.managerRef.id === this.$store.state.user.id
            )
              return true
          }

          return selectedFilters.some((role) => {
            const filter = [
              ...role.administrationLevelAllowed,
              ...role.autonomicAllowed,
              ...role.sourceEntityAllowed,
            ]
            if (!role.isCustom) {
              // Filtros genéricos
              if (
                filter.includes(item.administrationLevel) ||
                filter.includes(item.autonomicCode) ||
                filter.includes(item.codigo_organismo_emisor) ||
                filter.includes(item.codigo_organismo_emisor_raiz)
              )
                return true
            } else {
              // Filtros específicos del usuario
              if (filter.length > 0) {
                const isInFilter =
                  filter.includes(item.administrationLevel) ||
                  filter.includes(item.autonomicCode) ||
                  filter.includes(item.codigo_organismo_emisor) ||
                  filter.includes(item.codigo_organismo_emisor_raiz)
                if (isInFilter && role.negativeEntities) return false
                else if (!isInFilter && !role.negativeEntities) return false
              }

              // --- Validación de oficina remitente ---
              let passesOficinaRemitente = true
              if (
                Array.isArray(role.oficinaRemitente) &&
                role.oficinaRemitente.length > 0
              ) {
                if (
                  !role.comparisonOficina ||
                  role.comparisonOficina === '=='
                ) {
                  passesOficinaRemitente = role.oficinaRemitente.some(
                    (oficina) =>
                      item.metadatas?.some((m) =>
                        m.oficinaRemitente
                          ?.toLowerCase()
                          .includes(oficina.toLowerCase())
                      )
                  )
                } else if (role.comparisonOficina === '!=') {
                  // Ninguna oficina del documento puede estar en el filtro
                  passesOficinaRemitente =
                    item.metadatas?.every(
                      (m) =>
                        !role.oficinaRemitente.some((oficina) =>
                          m.oficinaRemitente
                            ?.toLowerCase()
                            .includes(oficina.toLowerCase())
                        )
                    ) ?? true
                }

                if (!passesOficinaRemitente) return false
              }

              // --- Validación de concepto ---
              let passesConcepto = true
              if (Array.isArray(role.concepto) && role.concepto.length > 0) {
                const joinedConcepts = this.joinConcepts(item).toLowerCase()
                if (
                  !role.comparisonConcepto ||
                  role.comparisonConcepto === '=='
                ) {
                  // Al menos un concepto configurado debe estar contenido en el string concatenado del doc
                  passesConcepto = role.concepto.some((c) =>
                    joinedConcepts.includes(c.toLowerCase())
                  )
                } else if (role.comparisonConcepto === '!=') {
                  // Ningún concepto configurado puede estar contenido en el string concatenado del doc
                  passesConcepto = role.concepto.every(
                    (c) => !joinedConcepts.includes(c.toLowerCase())
                  )
                }

                if (!passesConcepto) return false
              }

              // --- Validación de tipos ---

              // If there is a missing field we do not check the types and we accept the notification
              //if (!role.types || !role.comparisonType) return true

              let passesTypes = true
              if (
                Array.isArray(role.types) &&
                role.types.length > 0 &&
                role.comparisonType
              ) {
                //return role.comparisonType == '=='
                passesTypes =
                  role.comparisonType === '=='
                    ? role.types.some(
                        // Comparing the type with the ones in the metadatas.
                        // We just need one type in the metadata to be in the filter type to accept the notification.
                        // If the notification does not have metadatas, we return false
                        (type) =>
                          item.metadatas?.some((m) => m.tipo === type) ||
                          item.conceptoTipo === type
                      )
                    : role.types.every(
                        // Comparing the type with the ones in the metadatas.
                        // All the types in the notification have to be different than the ones in the filter.
                        // If the notification does not have metadatas, we return true
                        // (all the types are different because there are no types)
                        (type) =>
                          (item.metadatas?.every((m) => m.tipo !== type) ??
                            true) &&
                          item.conceptoTipo !== type
                      )
              }

              return passesOficinaRemitente && passesConcepto && passesTypes
            }
          })
        })
      }

      // 6) codigo_organismo_emisor
      if (customFilter && codigo_organismo_emisor) {
        const term = codigo_organismo_emisor.trim().toUpperCase()
        advancedSearchFiltered = advancedSearchFiltered.filter((item) =>
          item.codigo_organismo_emisor?.toUpperCase().includes(term)
        )
      }

      // 7) nombre_organismo_emisor
      if (customFilter && nombre_organismo_emisor) {
        const term = normalizeSearch(nombre_organismo_emisor)
          .trim()
          .toUpperCase()
        advancedSearchFiltered = advancedSearchFiltered.filter((item) =>
          normalizeSearch(item.nombre_organismo_emisor)
            ?.toUpperCase()
            .includes(term)
        )
      }

      // 8) codigo_organismo_emisor_raiz
      if (customFilter && codigo_organismo_emisor_raiz) {
        const term = codigo_organismo_emisor_raiz.trim().toUpperCase()
        advancedSearchFiltered = advancedSearchFiltered.filter((item) =>
          item.codigo_organismo_emisor_raiz?.toUpperCase().includes(term)
        )
      }

      // 9) nombre_organismo_emisor_raiz
      if (customFilter && nombre_organismo_emisor_raiz) {
        const term = normalizeSearch(nombre_organismo_emisor_raiz)
          .trim()
          .toUpperCase()
        advancedSearchFiltered = advancedSearchFiltered.filter((item) =>
          normalizeSearch(item.nombre_organismo_emisor_raiz)
            ?.toUpperCase()
            .includes(term)
        )
      }

      // 10) Concepto: búsqueda texto libre
      if (concepto) {
        // Se añade la posibilidad de tener varias palabras separadas entre si por una coma.
        // Acepta tanto "palabra1 , palabra2 , palabra3" como "palabra1,palabra2,palabra3"
        const terms = concepto
          .split(',')
          .map((t) => t.trim())
          .filter((t) => t.length > 0)
          .map((t) => normalizeSearch(t).toUpperCase())

        if (terms.length) {
          advancedSearchFiltered = advancedSearchFiltered.filter((item) => {
            const text = normalizeSearch(item.concepto || '').toUpperCase()
            return terms.some((term) => text.includes(term))
          })
        }
      }

      // 11) Tipo envio: Notificaciones='2' , Comunicaciones='1', ambas='0'
      if (tipo_envio !== '0') {
        advancedSearchFiltered = advancedSearchFiltered.filter(
          (item) => item.tipo_envio === tipo_envio
        )
      }

      // 12) Filtrar por usuarios y grupos responsable seleccionados
      const selectedResponsible = [...selectedUsers, ...selectedGroups]

      if (Array.isArray(selectedResponsible) && selectedResponsible.length) {
        const userIds = new Set(selectedResponsible.map((u) => u.id))
        advancedSearchFiltered = advancedSearchFiltered.filter((item) => {
          const inSelected = userIds.has(item.managerRef?.id)

          // Si no está en selectedResponsible, miramos si es un caso especial y si esta marcado su checkbox:
          // - notificacion sin responsable
          if (
            !inSelected &&
            this.isEmptyResponsible(item) &&
            withoutResponsible
          ) {
            return true
          }

          // Si no es un caso especial que ya haya sido incluido
          return inSelected
        })
      }

      // 13) 'withoutResponsible': si es false filtramos las notificaciones que no tienen responsable asignado
      if (!withoutResponsible) {
        advancedSearchFiltered = advancedSearchFiltered.filter(
          (item) => this.isEmptyResponsible(item) === withoutResponsible
        )
      }

      // 14) Alertas: filtrar por estados de alerta seleccionados
      if (Array.isArray(selectedAlertStatus) && selectedAlertStatus.length) {
        const alertStatusSet = new Set(selectedAlertStatus.map((a) => a.status))
        advancedSearchFiltered = advancedSearchFiltered.filter(
          (item) =>
            item.alert && alertStatusSet.has(getAlertStatus(item.alert).status)
        )
      }

      // 15-16) Alertas: filtrar por fecha-desde si hubiera y por fecha-hasta si hubiera
      let fromTime = null
      if (alertInitialDate) {
        const d = new Date(alertInitialDate)
        d.setHours(0, 0, 0, 0)
        fromTime = d.getTime()
      }

      let toTime = null
      if (alertFinalDate) {
        const d = new Date(alertFinalDate)
        d.setHours(23, 59, 59, 999)
        toTime = d.getTime()
      }

      if (alertInitialDate || alertFinalDate) {
        // filtra en un único .filter() con ambas condiciones de fechas
        advancedSearchFiltered = advancedSearchFiltered.filter((item) => {
          if (!item.alert) return false
          const t = item?.alert?.date.getTime()
          // filtro desde
          if (fromTime !== null && t < fromTime) return false
          // filtro hasta
          if (toTime !== null && t > toTime) return false

          return true // pasa todos los filtros
        })
      }

      // 17) Alertas: filtrar por el texto de la alerta: búsqueda texto libre
      if (alertText) {
        // Se añade la posibilidad de tener varias palabras separadas entre si por una coma.
        // Acepta tanto "palabra1 , palabra2 , palabra3" como "palabra1,palabra2,palabra3"
        const alertTerms = alertText
          .split(',')
          .map((t) => t.trim())
          .filter((t) => t.length > 0)
          .map((t) => normalizeSearch(t).toUpperCase())

        if (alertTerms.length) {
          advancedSearchFiltered = advancedSearchFiltered.filter((item) => {
            if (item.alert) {
              const text = normalizeSearch(item.alert?.text || '').toUpperCase()
              return alertTerms.some((term) => text.includes(term))
            } else {
              return false
            }
          })
        }
      }

      // 18) Observaciones: búsqueda texto libre
      if (observation) {
        // Se añade la posibilidad de tener varias palabras separadas entre si por una coma.
        // Acepta tanto "palabra1 , palabra2 , palabra3" como "palabra1,palabra2,palabra3"
        const terms = observation
          .split(',')
          .map((t) => t.trim())
          .filter((t) => t.length > 0)
          .map((t) => normalizeSearch(t).toUpperCase())

        if (terms.length) {
          advancedSearchFiltered = advancedSearchFiltered.filter((item) => {
            const text = normalizeSearch(item.observation || '').toUpperCase()
            return terms.some((term) => text.includes(term))
          })
        }
      }

      // 19) Metadatas: búsqueda texto libre en cualquiera de los metadatos que existan, y
      // que pueden estar en 2 atributos distintos:
      // a) notification.metadatas[]: extraidos del xml o del pdf
      // b) notification.conceptoMetadatos[] : extraidos a partir del .concepto (p.e MultasDGT, Expedientes TGSS)
      if (metadatas) {
        // Se añade la posibilidad de tener varias palabras separadas entre si por una coma.
        // Acepta tanto "palabra1 , palabra2 , palabra3" como "palabra1,palabra2,palabra3"
        const terms = metadatas
          .split(',')
          .map((t) => t.trim())
          .filter((t) => t.length > 0)
          .map((t) => normalizeSearch(t).toUpperCase())

        if (terms.length) {
          advancedSearchFiltered = advancedSearchFiltered.filter((item) => {
            // función auxiliar para recorrer los arrays de objetos
            const matchesInArray = (arr = []) => {
              return arr.some((entry) => {
                // entry es un objeto con varias claves, cada uno de los metadatos
                return Object.values(entry).some((value) => {
                  if (!value) return false
                  const text = normalizeSearch(value).toUpperCase()
                  return terms.some((term) => text.includes(term))
                })
              })
            }

            // comprobar en metadatas o en conceptoMetadatos
            return (
              matchesInArray(item.metadatas) ||
              matchesInArray(item.conceptoMetadatos)
            )
          })
        }
      }

      // 20) Notificaciones de empresas no registradas: checkbox a true
      if (cifsNotRegisteredShowAll === true) {
        advancedSearchFiltered = advancedSearchFiltered.filter((item) => {
          return (
            item.titular_original_modificado === '1' &&
            item.titular_original_nif &&
            item.titular_original_nombre
          )
        })
      }

      // 21) Notificaciones de empresas no registradas: búsqueda texto libre
      if (cifsNotRegistered) {
        // Se añade la posibilidad de tener varias palabras separadas entre si por una coma.
        // Acepta tanto "palabra1 , palabra2 , palabra3" como "palabra1,palabra2,palabra3"
        const terms = cifsNotRegistered
          .split(',')
          .map((t) => t.trim())
          .filter((t) => t.length > 0)
          .map((t) => normalizeSearch(t).toUpperCase())

        if (terms.length) {
          advancedSearchFiltered = advancedSearchFiltered.filter((item) => {
            const titularOriginalNif = normalizeSearch(
              item.titular_original_nif || ''
            ).toUpperCase()
            const titularOriginalNombre = normalizeSearch(
              item.titular_original_nombre || ''
            ).toUpperCase()

            return terms.some((term) => {
              return (
                titularOriginalNif.includes(term) ||
                titularOriginalNombre.includes(term)
              )
            })
          })
        }
      }

      return advancedSearchFiltered
    },
    getLoadLastDays() {
      return this.$store.state.user?.clientConfiguration?.loadLastDays ?? 90
    },
    getLoadLastDaysLimit() {
      return (
        this.$store.state.user?.clientConfiguration?.loadLastDaysLimit ??
        undefined
      )
    },
    periods() {
      return (
        this.$store.state.user?.clientConfiguration?.loadLastPeriod ?? undefined
      )
    },
    userCanChangePeriod() {
      // de momento cualquier usuario puede cambiar, despues ya iremos viendo
      return true
    },
    limitReached() {
      return this.loadAllNotifications
        ? false
        : this.$store.state.notifications.length >= this.getLoadLastDaysLimit
    },
    userCanUseAdvancedSearch() {
      // de momento cualquier usuario puede ejecutar busquedas avanzadas, despues ya iremos viendo
      return true
    },
    uniqueManagers() {
      // Para el caso de un superadmin se devuelve un array vacio y será el
      // componente de busqueda avanzada quien se encargue de cargar todos los operadores
      // Se amplia tambien a los operadores con permisos de admin
      if (this.isSuperAdminUser || this.isSuperOperatorUser) return []

      // Para el caso de un operador se devuelve un array con los usuarios
      // responsables que 've' en su lista de notificaciones, sin duplicados.
      const seen = new Set()
      //return this.filteredNotifications.reduce((list, doc) => {
      return this.notifications.reduce((list, doc) => {
        const user = doc.manager
        if (user) {
          user.isGroup = this.isGroup(doc.managerRef) // Marca al responsable si se trata de un grupo, para busqueda avanzada.
        }
        if (user && !seen.has(user.id)) {
          seen.add(user.id)
          list.push(user)
        }
        return list
      }, [])
    },
    searchLabel() {
      return this.isSearchFocused
        ? this.$t('searches.searchHelp')
        : this.$t('searchField')
    },
    searchTerms() {
      // Ahora se permite realizar una búsqueda de varias palabras separadas por comas
      return this.debouncedSearch
        ? this.debouncedSearch
            .split(',')
            .map((s) => s.trim().toUpperCase())
            .map(normalizeSearch) // normalización para eliminar acentos
            .filter((term) => typeof term === 'string' && term.length > 0)
        : ''
    },
    isLoadingAnything() {
      return this.loading || this.loadingAll
    },
    operatorsMap() {
      const map = {}
      for (const operator of this.operators || []) {
        map[operator.id] = operator
      }
      return map
    },
    groupsOperatorsMap() {
      const map = {}
      if (!this.groups?.length) return map

      for (const group of this.groups || []) {
        // guardamos solo los ids de los operadores del grupo y un par de metadatos, nada de objetos
        map[group.id] = {
          operatorIds: (group.usersRef || []).map((ref) => ref.id),
          deleted: group.deleted,
          name: group.fullName,
        }
      }
      return map
    },
    userHasSorted() {
      // Comprueba si el usuario ha reordenado el listado
      return this.options.sortBy.length > 0 || this.options.sortDesc.length > 0
    },
    totalPages() {
      // Calcula el total de páginas del listado en funcion de las filas por pagina.
      // Evita divisiones por 0; evita mostrar pagina 1/0, cuando no hay resultados, muestra en su lugar pagina 1/1
      return Math.max(
        1,
        Math.ceil(
          this.filteredNotifications.length /
            Math.max(1, this.options.itemsPerPage || 25)
        )
      )
    },
    goToPageTooltip() {
      return this.$t('goToPageTooltip', { max: this.totalPages })
    },
    tableHeight() {
      //TODO - ver como se podria hacer mejor y calcular la altura a partir de:
      // window.innerHeight
      // la altura del toolbar
      // la altura del v-card-title
      // la altura del v-footer
      // un pequeño margen
      // asi no dependería del zoom sino del espacio realmente disponible ...
      //
      // Calcula dinamicamente la altura del v-data-table, en lugar de indicar un valor fijo
      // con un zoom del 80% el valor sería de 600 (en mi pantalla, resolucion 1080 y configuracion tamaño de texto en Windows del 125%)
      // con un zoom del 100% el valor sería de 400
      return window.innerHeight > 900 ? 600 : 500
    },
    lastVisitedId() {
      const nav = this.$store.state.notificationNav
      const id = nav?.ids?.[nav.index] ?? null
      return id
    },
  },
  async destroyed() {
    if (this.operatorsUnsubscribe) {
      this.operatorsUnsubscribe()
      clearOperatorsHeavyCache()
    }
    if (this.groupsUnsubscribe) this.groupsUnsubscribe()
  },
  async created() {
    const userId = this.isOperatorUser
      ? this.$store.state.user.parentRef.id
      : this.$store.state.user.id

    this.operatorsUnsubscribe = await getOperatorsSubscriptionReduced(
      userId,
      this
    )

    this.groupsUnsubscribe = await getGroupsSubscription(this)

    //this.options = this.$store.state.notificationsListOptions
    const optionsSaved = this.$store.state.notificationsListOptions
    if (optionsSaved) {
      this.options = {
        ...this.options,
        ...optionsSaved,
      }
    }

    this.maxMassiveActionItems =
      this.$store.state.massiveActionsSettings?.maxSelectedItems || 10
    this.search = this.$store.state.notificationsSearch
    this.currentAdvancedSearch = this.$store.state.notificationsAdvancedSearch
    this.currentPeriod = this.$store.state.notificationsCurrentPeriod
    if (this.currentPeriod) {
      this.openGridNotifications = false
      await this.loadAll(this.currentPeriod)
    }
  },
  mounted() {
    this.loadAllNotifications = this.$store.state.notificationsCurrentPeriod
      ? true
      : false

    // Para la busqueda 'normal':
    // Espera 300 ms tras pulsar la ultima tecla. Asi no se sobrecarga la CPU mientras el usuario escribe
    // nota: se usa .bind(this) para asegurar que 'this' dentro de la función del debounce sigue
    // apuntando al componente Vue.
    this.handleDebouncedSearch = lodash.debounce(
      function (val) {
        this.debouncedSearch = val
      }.bind(this),
      300
    )

    // Eliminar el flag para evitar que el watcher tambien lo procese
    this.$store.commit('consumeNotificationsReloaded')
  },
  beforeUnmount() {
    clearTimeout(this.loadingTimeout)
    this.loadingTimeout = null
  },
  watch: {
    cifs: function (newValue) {
      if (newValue) {
        this.loadedCifs = newValue
      }
    },
    cifsList: function (newValue) {
      if (newValue) {
        this.loadedCifsList = newValue
      }
    },
    notificationsWithoutNifTitular: {
      handler(newArray) {
        this.openGridNotifications = newArray.length > 0
        if (this.openGridNotifications) {
          this.closeAdvancedSearchDialog()
        }
      },
      immediate: true, // Ejecuta el watcher cuando el componente se monta
    },
    isLoadingAnything(newVal) {
      clearTimeout(this.loadingTimeout)

      if (newVal) {
        this.loadingTimeout = setTimeout(() => {
          this.showLongLoadingModal = true
        }, 5000)
      } else {
        this.showLongLoadingModal = false
      }
    },
    search(val) {
      // cada vez que el usuario escriba una letra llama a la funcion de retardo
      this.handleDebouncedSearch(val)
    },
    selectedRows(val, oldVal) {
      if (
        this.massiveActionSelected === 'openNotification' &&
        val.length > this.maxMassiveActionItems
      ) {
        // Mostrar diálogo de límite alcanzado
        this.dialogLimitReached = true
        this.$nextTick(() => {
          this.selectedRows = oldVal
        })
      }
    },
    notifications: {
      handler(newList, oldList) {
        if (!Array.isArray(newList) || !Array.isArray(oldList)) {
          return
        }

        // Detectar una recarga completa de las notificaciones en el store
        if (this.$store.state.notificationsReloaded === true) {
          for (const item of newList) {
            this.loadGroupData(item, { forceReset: true, showLoading: true })
          }
          // Eliminar el flag
          this.$store.commit('consumeNotificationsReloaded')
          return
        }

        // Si no se trata de una recarga desde el store
        const oldMap = new Map(oldList.map((o) => [o.id, o]))

        for (const item of newList) {
          const oldItem = oldMap.get(item.id)

          // nuevo item
          if (!oldItem) {
            this.loadGroupData(item, { forceReset: true, showLoading: true })
            continue
          }

          // cambios realmente relevantes
          if (
            item.managerAccepted !== oldItem.managerAccepted ||
            (item.responseOperators?.length ?? 0) !==
              (oldItem.responseOperators?.length ?? 0) ||
            item.manager?.disabled !== oldItem.manager?.disabled ||
            item.manager?.deleted !== oldItem.manager?.deleted
          ) {
            this.loadGroupData(item, { forceReset: false, showLoading: true })
          }
        }
      },
    },
    operators: {
      async handler(newVal, oldVal) {
        if (!oldVal || newVal === oldVal) return
        // los operadores suscritos han cambiado, recalcula colores de los avatares de operadores
        // averiguar qué operador ha cambiado y en que afecta (name, surname, disabled ...) porque la
        // mayoria de atributos no influyen en esto
        let changed = null
        for (const op of newVal) {
          const prev = oldVal.find((item) => item.id === op.id)
          if (!prev) {
            // operador nuevo, añadido
            continue
          }

          const prevMap = prev.cifsPermissions || {}
          const nextMap = op.cifsPermissions || {}
          // Detectar borrado de claves en el mapa cifsPermissions, lo que significa empresa borrada al operador
          const removed = Object.keys(prevMap).filter((k) => !(k in nextMap))
          // Detectar nuevas claves en el mapa cifsPermissions, lo que significa empresa añadida al operador
          const added = Object.keys(nextMap).filter((k) => !(k in prevMap))

          if (
            prev.name !== op.name ||
            prev.surname !== op.surname ||
            prev.disabled !== op.disabled ||
            removed.length > 0 ||
            added.length > 0
          ) {
            changed = op
            break
          }
        }
        if (!changed) return

        const operatorsMap = this.operatorsMap

        // Caso el responsable es un operador:
        //  - filtrar aquellas notificaciones cuyo managerRef.id sea === al id del operador que ha cambiado,
        // Caso el responsable es un grupo:
        //  - Si cambia un operador
        //  - Y ese operador pertenece a un grupo responsable
        //  - Recalcular solo esas notificaciones
        //
        // y luego actualizar unicamente ese conjunto de notificaciones, no todas.
        const affectedNotifications = this.notifications.filter((item) => {
          if (!item.managerRef) return false

          // Caso 1: operador es responsable directo
          if (item.managerRef.id === changed.id) return true

          // Caso 2: responsable es grupo y el operador pertenece al grupo cargado
          if (
            this.isGroup(item.managerRef) &&
            this.getGroupOperators(item).some((op) => op.id === changed.id)
          ) {
            return true
          }

          return false
        })

        await Promise.all(
          affectedNotifications.map(async (doc) => {
            // Si el responsable es operador, se actualiza manager
            if (!this.isGroup(doc.managerRef)) {
              const newManager =
                operatorsMap[doc.managerRef.id] ??
                (await GetDocumentFromReference(doc.managerRef))

              doc.manager = newManager
              // actualiza el cambio en el store mediante una nueva mutacion
              this.$store.commit('updateNotificationManager', {
                id: doc.id,
                manager: newManager,
              })
            }

            // En ambos casos (operador directo o grupo)
            return this.loadGroupData(doc, {
              forceReset: false,
              showLoading: true,
            })
          })
        )
      },
    },
    groups: {
      async handler(newVal, oldVal) {
        if (!Array.isArray(newVal) || !Array.isArray(oldVal)) {
          return
        }
        // los grupos suscritos han cambiado, recalcula colores de los avatares de grupos
        // averiguar qué grupo ha cambiado y en que afecta (name, deleted, arrays de referencias ...)
        let changed = null

        for (const grp of newVal) {
          const prev = oldVal.find((item) => item.id === grp.id)
          if (!prev) {
            // grupo nuevo, añadido
            continue
          }

          if (this.hasGroupChanged(prev, grp)) {
            changed = grp
            break
          }
        }
        if (!changed) return

        const groupsById = {}
        for (const g of this.groups) {
          groupsById[g.id] = g // a diferencia del mapa groupsOperatorsMap, esto si contiene todo el objeto completo suscrito.
        }

        await Promise.all(
          this.notifications
            .filter((item) => item.managerRef?.id === changed.id)
            .map(async (doc) => {
              const newManager =
                groupsById[doc.managerRef.id] ??
                (await GetDocumentFromReference(doc.managerRef))

              doc.manager = newManager
              // actualiza el cambio en el store mediante una nueva mutacion
              this.$store.commit('updateNotificationManager', {
                id: doc.id,
                manager: newManager,
              })

              return this.loadGroupData(doc, {
                forceReset: false,
                showLoading: false,
              })
            })
        )
      },
    },
    groupsOperatorsMap: {
      immediate: true,
      handler(map) {
        if (!map) return
        this.notifications.forEach((item) => {
          if (item.managerRef) {
            this.loadGroupData(item, { forceReset: true, showLoading: true })
          }
        })
      },
    },
    'options.page'(page) {
      this.pageInput = page
    },
  },
}
</script>

<style>
.v-data-table-header th {
  white-space: nowrap;
}

.no-italics {
  font-style: normal;
}

.without-nif-alarm {
  background-color: #d70a0a;
  color: white;
  font-weight: bold;
  padding: 6px 6px;
  border-radius: 4px;
  white-space: nowrap;
  width: auto;
}

.nif-wrapper {
  display: inline-flex;
  align-items: center;
}

/* tooltip de grupo: color gris un poco mas oscuro y eliminar la transparencia */
.tooltip-no-transparency {
  background-color: rgba(97, 97, 97, 1) !important; /* opaco */
  opacity: 1 !important; /* sin transparencia */
  color: #ffffff; /* texto base legible */
}

.group-operators-info {
  display: flex;
  align-items: center; /* Alinea chip y texto verticalmente */
  margin-top: 12px; /* Igual que mt-3 */
  padding-left: 8px; /* Ajusta al borde izquierdo del tooltip */
}

.operator-count-chip {
  margin-right: 8px; /* espacio entre chip y texto */
}

.operator-count-text {
  font-size: 0.875rem; /* Igual que body-2, ajustable */
  color: #ffffff; /* texto base legible */
}

.tooltip-loading {
  min-width: 260px;
  min-height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.group-deleted {
  background-color: #d70a0a;
  color: white;
  /*font-weight: bold;*/
  padding: 2px 2px;
  border-radius: 2px;
}

/* Selector de pagina */
.page-input {
  width: 28px;
  text-align: center;
  padding: 0;
  margin: 0 3px;
  line-height: inherit;
  border: none;
  outline: none;
  background: transparent;
  font: inherit;
  color: inherit;
  /*border-bottom: 1px dotted currentColor;*/
  /*border-bottom: 1px dashed rgba(0, 0, 0, 0.3);*/
  border-bottom: 1px dashed transparent;
  transition: border-color 0.2s ease;
  position: relative;
  top: 1px;
}

.page-input:focus {
  border-bottom: 1px dashed var(--v-primary-base);
}

.page-selector {
  display: inline-flex;
  align-items: center;
  cursor: help;
}

/* Selector de pagina, eliminar los spin buttons para incrementar-decrementar un numero */
/* Para navegadores basados en Webkit (Chrome, Safari, Edge y Opera) */
.page-input::-webkit-outer-spin-button,
.page-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* Para Mozilla Firefox */
.page-input {
  -moz-appearance: textfield;
}

/* 
 Al volver de la navegacion resaltar, como si tuviera el hover, 
 durante 4 segundos la fila que contiene la ultima notificacion visitada. 
*/
.last-visited-row {
  animation: highlight-row 4s ease;
}

@keyframes highlight-row {
  0% {
    background: #eeeeee;
  }

  80% {
    background: #eeeeee;
  }

  100% {
    background: transparent;
  }
}
</style>
